import React, { useState, useCallback, useEffect, useMemo, useRef } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { PageBase } from "../../Components/PageBase";
import { FabButton } from "../../Components/FabButton";
import { useRol } from "../../Context";
import { secureSetItem, secureGetItem } from '../../utils/encryption';
import { getCsrfToken } from '../../utils/csrf';
import { LoadingOverlay } from "../../Components/UX/LoadingOverlay";
import "./ContactosV3.css"
import { DateTime } from 'luxon';
import moment from 'moment';
import 'moment/locale/es';
import { format } from 'date-fns';
import Modal from '../../Components/Modal';
import tresPuntitos from "../../icons/tres-puntitos.svg"
import tresPuntitosPink from "../../icons/tres-puntitos-pink.svg"
import lupaSearch from "../../icons/lupaV3.svg"
import bd from "../../icons/server-sharp.svg";
import fb from "../../icons/logo-facebook-lead.svg";
import insta from "../../icons/logo-instagram.svg";
import wats from "../../icons/logo-whatsapp-lead.svg";
import tiktok from "../../icons/logo-tiktok.svg";
import mundo from "../../icons/earth.svg";
import diam from "../../icons/diamond.svg";
import mano from "../../icons/hand-right.svg";
import person from "../../icons/person-lead.svg";
import image from "../../icons/image.svg";
import periodico from "../../icons/newspaper-outline.svg";
import radio from "../../icons/mic.svg";
import pesos from "../../icons/logo-usd-lead.svg";
import revista from "../../icons/library.svg";
import chats from "../../icons/chatbubbles-outline.svg";
import trail from "../../icons/trail-sign-outline.svg";
import call from "../../icons/call-lead.svg";
import tv from "../../icons/tv-outline.svg";
import receipt from "../../icons/receipt-outline.svg";
import acess from "../../icons/accessibility.svg";
import laptop from "../../icons/laptop-outline.svg";
import help from "../../icons/help.svg";
import google from "../../icons/logo-google.svg";
import linkedin from "../../icons/briefcase-sharp.svg"
import feliz from "../../icons/emoji-feliz.png";
import serio from "../../icons/emoji-serio.png";
import triste from "../../icons/emoji-triste.png";
import congelado from "../../icons/emoji-congelado.png";
import accion from '../../icons/create-outline.svg';
import accionhover from '../../icons/create-outline (1).svg';
import personV3 from '../../icons/personV3.svg';
import informacion from "../../icons/informacion.svg";
import tareas from "../../icons/tareasV3.svg";
import historial from "../../icons/historial.svg";
import whats from "../../icons/whatsapp.svg";
import intentos from "../../icons/Icono-sin-fondo.svg";
import informacionNA from "../../icons/informacionNA.svg";
import tareasNA from "../../icons/tareasV3NA.svg";
import historialNA from "../../icons/historialNA.svg";
import whatsNA from "../../icons/whatsappNA.svg";
import intentosNA from "../../icons/Icono-sin-fondoNA.svg";
import iconSvg from '../../icons/add-circle.svg';
import send from '../../icons/send-sharp.svg';
// import flechaAtras from '../../icons/flechaAtras-V3.svg';
import enviado from '../../icons/checkmarkV3.svg';
import check from '../../icons/checkmarkV3-intento.svg';
import clip from '../../icons/attach.svg';
import carita from '../../icons/happy-outline.svg';
import recibido from '../../icons/checkmark-done.svg';
import visto from '../../icons/checkmark-done-sharp.svg';
import image2 from "../../icons/candidates-Vacants.png";
import img2 from "../../icons/calendar-number-outline.svg";
import checkWite from '../../icons/checkmark (1).svg';
import checkgreen from '../../icons/checkmark-green.svg';
import imgMovil from "../../icons/candidates-Vacants.png";
import transfer from '../../icons/Transfer.svg';
import trashIcon from '../../icons/trash.svg';
import downloadMovil from '../../icons/download.svg';
import filterMovil from '../../icons/funnel.svg';
import iconSvg2 from '../../icons/backspace.svg';
// import close from "../../icons/closeWA.svg";
import addBlack from "../../icons/add-circleBlack.svg";
import downloadBlack from "../../icons/downloadBlack.svg";
import filterBlack from "../../icons/filter.svg";
import pencil from "../../icons/pencil.svg";
import { Loading } from "../../Components/UX/Loading";
import chevronBackGrey from "../../icons/chevron-back-grey.svg";
import chevronForwardGrey from "../../icons/chevron-forward-grey.svg";

function ContactosV3() {

    const {
        filteredContacts,
        setFilteredContacts,
        setIdLead,
        dataLead,
        setDataLead,
        searchTerm,
        setSearchTerm,
        handleTagChange,
        handleContractingStatusChange,
        leads,
        numIntentByLead,
        setNumIntentByLead,
        listaUsers,
        dataProfile,
        agePATCH,
        setValorSelect1,
        marital_statusPATCH,
        setValorSelect2,
        life_statusPATCH,
        setValorSelect3,
        genderPATCH,
        setValorSelect4,
        purchase_reasonPATCH,
        setValorSelect5,
        purchase_timePATCH,
        setValorSelect6,
        budgetPATCH,
        setValorSelect7,
        payment_typePATCH,
        setValorSelect8,
        originPATCH,
        setValorSelect9,
        contact_typePATCH,
        setValorSelect10,
        tag,
        setValorSelect11,
        cityPATCH,
        setValorInput1,
        postulation_date,
        setValorInput2,
        visited_date,
        setValorInput3,
        handlePatchRequest,
        tasksByLead,
        tasksByLeadOpen,
        tasksByLeadFinish,
        intentosV3,
        historialV3,
        historialCompleto,
        setHistorialCompleto,
        setTitle,
        newTitle,
        setNewTitle,
        newObservation,
        setNewObservation,
        handleNotesCreate,
        nameUser,
        setNumeroUser,
        setMyUser,
        nameMyUser,
        userName,
        user,
        tagUrl,
        setTag,
        originUrl,
        setOriginUrl,
        seguimiento,
        setSeguimiento,
        periodo,
        setPeriodo,
        visited,
        setVisited,
        recruiter_id,
        setRecruiterId,
        rol,
        rolOriginal,
        rolActivo,
        Id,
        setUpLead,
        apiErrorMessage: contextApiErrorMessage,
        setApiErrorMessage: setContextApiErrorMessage,
        shouldCloseModal,
        setShouldCloseModal,
        vacantCode,
        projects,
        interest,
        initial_comment,
        setBtnCreateLead,
        title,
        description,
        setDescription,
        expiration,
        type_task,
        setType_Task,
        setTask_Status,
        setTasksByLeadOpen,
        handlePosthTasksByLeadRequest,
        handlePatchSeleccion,
        handlePatchDiscard,
        setExpiration,
        setLeads,
        handleButtonClickIndicadores,
        handlePatch2Request,
        setCandidate_Name,
        setEmail,
        setPhone_Number,
        activeButton,
        loading,
    } = useRol();

    // Estado para el hover del botón de tres puntos
    const [isTresPuntitosHovered, setIsTresPuntitosHovered] = useState(false);



    // Función para obtener el nombre del recruiter
    const getRecruiterName = (recruiterId) => {
        if (!listaUsers || !recruiterId || recruiterId === null) return 'Sin asignar';
        const recruiter = listaUsers.find(user => user.id === recruiterId);
        return recruiter ? recruiter.first_name : 'Sin asignar';
    };

    // Función para obtener el nombre completo del usuario actual
    const getCurrentUserName = () => {
        if (dataProfile && dataProfile.first_name && dataProfile.last_name) {
            return `${dataProfile.first_name} ${dataProfile.last_name}`;
        } else if (dataProfile && dataProfile.first_name) {
            return dataProfile.first_name;
        }
        return 'Usuario';
    };

    const postActionNote = async (leadId, title, observation) => {
        if (!leadId || !Id) return;
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/notes`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCsrfToken() },
                body: JSON.stringify({ title, observation, candidate: leadId, user: Id, type_note: 'accion' }),
            });
            if (!res.ok) return;
            const data = await res.json();
            setHistorialCompleto(prev => [data, ...prev].sort((a, b) => new Date(b.created) - new Date(a.created)));
        } catch (e) {
            console.error('[postActionNote]', e);
        }
    };

    const navigate = useNavigate();

    // Modal **WEB** agregar contactos
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setCandidateNameError('');
        setEmailError('');
        setPhoneNumberError('');
        setAgeError('');
        setCityError('');
        setGenderError('');
        setContactTypeError('');
        setOriginError('');
        setContractingStatusError('');
        // setApiErrorMessage('');
        // Limpiar también el mensaje de error del contexto
        if (typeof setContextApiErrorMessage === 'function') {
            setContextApiErrorMessage('');
        }
        setIsModalOpen(false);
        setUpLead(null);
        // Limpiar estados del modal
        setModalCandidateName('');
        setModalEmail('');
        setModalPhoneNumber('');
        setModalAge('');
        setModalMaritalStatus('');
        setModalCity('');
        setModalLifeStatus('');
        setModalGender('');
        setModalPurchaseReason('');
        setModalPurchaseTime('');
        setModalBudget('');
        setModalPaymentType('');
        setModalContactType('');
        setModalOrigin('');
        setModalContractingStatus('');
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** descargar contactos
    const [isModalOpenDownLeadWeb, setIsModalOpenDownLeadWeb] = useState(false);
    const openModalDownLeadWeb = () => {
        setIsModalOpenDownLeadWeb(true);
    };
    const closeModalDownLeadWeb = () => {
        setIsModalOpenDownLeadWeb(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** acciones de contactos
    const [isModalOpenAccionesWeb, setIsModalOpenAccionesWeb] = useState(false);
    const openModalAccionesWeb = (idCandidate) => {
        setIdLead(idCandidate)
        // Resetear todos los inputs del modal
        setTitle('');
        setDescription('');
        setExpiration(undefined);
        setType_Task('');
        setNewTitle('');
        setNewObservation('');
        setIsModalOpenAccionesWeb(true);
    };
    const closeModalAccionesWeb = () => {
        setTitle('')
        setNewObservation('')
        setIsModalOpenAccionesWeb(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** filtro periodo por fecha
    const [isModalOpenFilterPeriod, setIsModalOpenFilterPeriod] = useState(false);
    const openModalFilterPeriod = () => {
        setIsModalOpenFilterPeriod(true);
    };
    const closeModalFilterPeriod = () => {
        setIsModalOpenFilterPeriod(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** filtros
    const [isModalOpenFiltros, setIsModalOpenFiltros] = useState(false);
    const openModalFiltros = () => {
        setIsModalOpenFiltros(true);
    };
    const closeModalFiltros = () => {
        setIsModalOpenFiltros(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB/MOVIL** descartar contactos
    const [isModalOpenOmitirDiscard, setIsModalOpenOmitirDiscard] = useState(false);
    const openModalOmitirDiscard = () => {
        setIsModalOpenOmitirDiscard(true);
    };
    const closeModalOmitirDiscard = () => {
        setIsModalOpenOmitirDiscard(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** agregar tareas perfil contacto
    const [isModalOpenTaskByLead, setIsModalOpenTaskByLead] = useState(false);
    const openModalTaskByLead = () => {
        // Resetear todos los inputs del modal
        setTitle('');
        setDescription('');
        setExpiration(undefined);
        setType_Task('');
        setIsModalOpenTaskByLead(true);
    };
    const closeModalTaskByLead = () => {
        setIsModalOpenTaskByLead(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** descartar lead en perfil contacto
    const [isModalOpen4, setIsModalOpen4] = useState(false);
    const openModal4 = () => {
        setIsModalOpen4(true);
    };
    const closeModal4 = () => {
        setTitle('')
        setNewObservation('')
        setIsModalOpen4(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** agregar contactos
    const [isModalOpenAddMovil, setIsModalOpenAddMovil] = useState(false);
    const openModalAddMovil = () => {
        setIsModalOpenAddMovil(true);
    };
    const closeModalAddMovil = () => {
        setCandidateNameError('');
        setEmailError('');
        setPhoneNumberError('');
        setAgeError('');
        setCityError('');
        setGenderError('');
        setContactTypeError('');
        setOriginError('');
        setContractingStatusError('');
        // setApiErrorMessage('');
        // Limpiar también el mensaje de error del contexto
        if (typeof setContextApiErrorMessage === 'function') {
            setContextApiErrorMessage('');
        }
        setIsModalOpenAddMovil(false);
        setUpLead(null);
        // Limpiar estados del modal
        setModalCandidateName('');
        setModalEmail('');
        setModalPhoneNumber('');
        setModalAge('');
        setModalMaritalStatus('');
        setModalCity('');
        setModalLifeStatus('');
        setModalGender('');
        setModalPurchaseReason('');
        setModalPurchaseTime('');
        setModalBudget('');
        setModalPaymentType('');
        setModalContactType('');
        setModalOrigin('');
        setModalContractingStatus('');
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** acciones de contactos
    const [isModalOpenAcciones, setIsModalOpenAcciones] = useState(false);
    const openModalAcciones = () => {
        // Resetear todos los inputs del modal
        setTitle('');
        setDescription('');
        setExpiration(undefined);
        setType_Task('');
        setNewTitle('');
        setNewObservation('');
        setIsModalOpenAcciones(true);
    };
    const closeModalAcciones = () => {
        setIsModalOpenAcciones(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** descargar contactos
    const [isModalOpenDownLeadMovil, setIsModalOpenDownLeadMovil] = useState(false);
    const openModalDownLeadMovil = () => {
        setIsModalOpenDownLeadMovil(true);
    };
    const closeModalDownLeadMovil = () => {
        setIsModalOpenDownLeadMovil(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** filtrar contactos
    const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
    const openModalFilter = () => {
        setIsModalOpenFilter(true);
    };
    const closeModalFilter = () => {
        setIsModalOpenFilter(false);
        document.body.style.overflow = 'visible';
    };

    let vacant_code = vacantCode

    const primeraLetra = nameMyUser.substring(0, 1);
    const [tableB, setTable] = useState(true)
    const [divDisplay, setDivDisplay] = useState('block');
    const [gridColumn, setGridColumn] = useState('span 3');
    const [gridColumn2, setGridColumn2] = useState(false);
    const [gridColumn3,
        // setGridColumn3
    ] = useState(false);
    const [gridLayout, setGridLayout] = useState(false);
    const [borderRadius, setBorderRadius] = useState('18px 18px 0px 0px');
    // const [borderRadius2, setBorderRadius2] = useState(false);
    const [hideScrollbar, setHideScrollbar] = useState(false);
    const [borderLeft, setBorderLeft] = useState('1px solid #a1a1a186');
    const [optionContac, setOptionContac] = useState('Informacion');
    const [tasksStatus, setTasksStatus] = useState('Abiertas');
    const [totalLength, setTotalLength] = useState(0);
    const [calificadoLength, setCalificadoLength] = useState(0);
    const [citaLength, setCitaLength] = useState(0);
    const [visitaLength, setVisitaLength] = useState(0);
    const [potencialLength, setPotencialLength] = useState(0);
    const [cierreLength, setCierreLength] = useState(0);
    // const [leadIds, setLeadIds] = useState([]);
    const [leadTasksInfo, setLeadTasksInfo] = useState([]);
    const [enModoEdicion, setEnModoEdicion] = useState(false);
    const [edicion, setEdicion] = useState(false);
    const [more, setMore] = useState(false);
    const [candidate_nameError, setCandidateNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [phone_numberError, setPhoneNumberError] = useState('');
    const [ageError, setAgeError] = useState('');
    const [cityError, setCityError] = useState('');
    const [genderError, setGenderError] = useState('');
    const [contact_typeError, setContactTypeError] = useState('');
    const [originError, setOriginError] = useState('');
    const [contracting_statusError, setContractingStatusError] = useState('');
    // const [apiErrorMessage, setApiErrorMessage] = useState(''); // Ya no se usa, se usa el del contexto

    // Estados para el perfil de contacto (infoBasic2-lead-v3)
    const [candidate_name, setNameLead] = useState('');
    const [email, setEmailLead] = useState('');
    const [phone_number, setPhoneLead] = useState('');

    // Estados para los modales de agregar contactos (separados del perfil)
    const [modalCandidateName, setModalCandidateName] = useState('');
    const [modalEmail, setModalEmail] = useState('');
    const [modalPhoneNumber, setModalPhoneNumber] = useState('');
    const [modalAge, setModalAge] = useState('');
    const [modalMaritalStatus, setModalMaritalStatus] = useState('');
    const [modalCity, setModalCity] = useState('');
    const [modalLifeStatus, setModalLifeStatus] = useState('');
    const [modalGender, setModalGender] = useState('');
    const [modalPurchaseReason, setModalPurchaseReason] = useState('');
    const [modalPurchaseTime, setModalPurchaseTime] = useState('');
    const [modalBudget, setModalBudget] = useState('');
    const [modalPaymentType, setModalPaymentType] = useState('');
    const [modalContactType, setModalContactType] = useState('');
    const [modalOrigin, setModalOrigin] = useState('');
    const [modalContractingStatus, setModalContractingStatus] = useState('');
    const [activeTab, setActiveTab] = useState('intentos');
    const [currentDate, setCurrentDate] = useState('');
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [selectedCell, setSelectedCell] = useState(null);
    const [stageSelected, setStageSelected] = useState(1);
    const [searchParams, setSearchParams] = useSearchParams();
    const initializedFromUrl = useRef(false);

    const cambiarEstado = () => {
        setTable(!tableB);
        setDivDisplay(divDisplay === 'block' ? 'none' : 'block');
        setGridColumn(gridColumn === 'span 3' ? 'span 12' : 'span 3');
        setGridColumn2(!gridColumn2);
        setGridLayout(!gridLayout);
        setBorderRadius(borderRadius === '18px 18px 0px 0px' ? '18px 0px 0px 0px' : '18px 0px 0px 0px')
        setHideScrollbar(!hideScrollbar);
        setBorderLeft(borderLeft === '1px solid #a1a1a186' ? 'none' : '1px solid #a1a1a186');
    };

    const handleMore = () => { setMore(!more); }

    /*const openInfoLead = () => {
        setBorderRadius2(true);
        // setGridColumn3(true);
    }*/

    /* const closeInfoLead = () => {
        setGridColumn3(false);
        setBorderRadius2(false);
    } */

    const handleOption = useCallback((option) => { setOptionContac(option); }, []);

    const handleTasks = useCallback((status) => { setTasksStatus(status); }, []);

    // Estado local para el input de búsqueda (para que sea responsive)
    const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
    const searchTimeoutRef = useRef(null);

    // Actualizar el término de búsqueda local cuando cambie el del contexto
    useEffect(() => {
        setLocalSearchTerm(searchTerm);
    }, [searchTerm]);

    const handleSearch = (event) => {
        const value = event.target.value;
        setLocalSearchTerm(value);

        // Limpiar el timeout anterior
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        // Esperar 500ms después de que el usuario deje de escribir
        searchTimeoutRef.current = setTimeout(() => {
            setSearchTerm(value);
            setPage(1);
        }, 500);
    };

    // Limpiar timeout al desmontar
    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);

    const StatusLength = ({ filteredContacts, status }) => {
        return useMemo(() => {
            if (!filteredContacts || !Array.isArray(filteredContacts)) return 0;
            return filteredContacts.filter((item) => item.contracting_status === status).length;
        }, [filteredContacts, status]);
    };

    // NOTA: Los contadores ahora se obtienen del backend mediante fetchTotalLeadsAndCounters
    // Se calculan a partir de todos los leads con los filtros aplicados

    function getOriginImage(origin) {
        switch (origin) {
            case 'Base_Datos':
            case 'Base Datos':
            case 'Base de Datos BBR':
                return bd;
            case 'Facebook':
            case 'Facebook_Desktop_Feed':
            case 'Facebook_Organic':
            case 'Facebook_Mobile_Feed':
            case 'Facebook_Instant_Articles':
            case 'Facebook Ads':
            case 'Facebook_Marketplace':
                return fb;
            case 'Google':
            case 'Google Ads':
            case 'Google_Organic':
            case 'Google_ads':
                return google;
            case 'Instagram':
            case 'Instagram Ads':
            case 'Instagram_Explore':
            case 'Instagram_Feed':
                return insta;
            case 'Whatsapp':
                return wats;
            case 'Tiktok':
                return tiktok;
            case 'Página web':
            case 'Pagina web':
            case 'Redes sociales':
            case 'Redes Sociales':
            case 'Web':
            case 'Facebook Forms':
            case 'Sitio web Forms':
                return mundo;
            case 'LinkedIn':
            case 'Linkedin':
            case 'linkedin':
                return linkedin;
            case 'Broker':
            case 'Asesores Externos':
            case 'Broker o Asesor Externo':
                return diam;
            case 'Cambaceo':
                return mano;
            case 'Contacto Directo':
                return person;
            case 'Espectacular':
            case 'Espectacular South Hill (Carretera Celaya)':
            case 'Lonas':
                return image;
            case 'Inmobiliaria Externa':
                return trail;
            case 'Periodico':
            case 'Periódico':
                return periodico;
            case 'Radio':
                return radio;
            case 'Recompra':
                return pesos;
            case 'Revista':
                return revista;
            case 'Referidos':
            case 'RECOMENDACIï¿½N':
                return chats;
            case 'Señaletica':
            case 'Señalética':
                return trail;
            case 'Telefono':
            case 'Teléfono':
                return call;
            case 'Televisión':
                return tv;
            case 'Volante':
                return receipt;
            case 'Inmuebles 24':
            case 'Lamudi':
            case 'Metros cúbicos':
            case 'Propiedades.com':
            case 'Segundamano':
            case 'Tu Hogar México':
            case 'Vivanuncios':
                return laptop;
            case 'Walk-in':
                return acess;
            default:
                return help;
        }
    }

    function getOriginLabel(origin) {
        const labels = {
            'Base_Datos': 'Base de Datos',
            'Base Datos': 'Base de Datos',
            'Base de Datos BBR': 'Base de Datos',
            'Facebook_Desktop_Feed': 'Facebook Ads',
            'Facebook_Organic': 'Facebook',
            'Facebook_Mobile_Feed': 'Facebook',
            'Facebook_Instant_Articles': 'Facebook',
            'Facebook Ads': 'Facebook Ads',
            'Facebook_Marketplace': 'Facebook',
            'Facebook Forms': 'Facebook Forms',
            'Google_Organic': 'Google',
            'Google_ads': 'Google Ads',
            'Google Ads': 'Google Ads',
            'Instagram Ads': 'Instagram',
            'Instagram_Explore': 'Instagram',
            'Instagram_Feed': 'Instagram',
            'Página web': 'Página web',
            'Redes sociales': 'Redes sociales',
            'Redes Sociales': 'Redes sociales',
            'Sitio web Forms': 'Sitio web',
            'Pagina web': 'Página web',
            'LinkedIn': 'LinkedIn',
            'Linkedin': 'LinkedIn',
            'linkedin': 'LinkedIn',
            'Broker': 'Broker',
            'Asesores Externos': 'Broker',
            'Broker o Asesor Externo': 'Broker',
            'Espectacular South Hill (Carretera Celaya)': 'Espectacular',
            'Periodico': 'Periódico',
            'RECOMENDACIï¿½N': 'Referidos',
            'Señaletica': 'Señalética',
            'Telefono': 'Teléfono',
        };
        return labels[origin] || origin || '';
    }

    const formatearFecha = useCallback((fecha) => {
        if (!fecha) {
            return 'Sin Visita';
        }

        const fechaActual = moment();
        const fechaDada = moment(fecha);

        const diferenciaMinutos = fechaActual.diff(fechaDada, 'minutes');

        if (diferenciaMinutos < 1440) {
            const horas = Math.floor(diferenciaMinutos / 60);
            const horaFormateada = moment(fecha).format('h:mm A');
            return horas < 24 ? `Hoy ${horaFormateada}` : `Ayer ${horaFormateada}`;
        } else if (diferenciaMinutos < 2880) {
            const horaFormateada = moment(fecha).format('h:mm A');
            return `Ayer ${horaFormateada}`;
        } else {
            const dias = Math.floor(diferenciaMinutos / 1440);

            if (dias <= 30) {
                return `Hace ${dias} días`;
            } else {
                const meses = Math.floor(dias / 30);

                if (meses < 12) {
                    return `Hace ${meses} ${meses === 1 ? 'mes' : 'meses'}`;
                } else {
                    return "Hace más de 1 año";
                }
            }
        }
    }, []);


    const formatearFechaVisita = (dateString) => {
        if (!dateString) return 'No visitó';
        const dateOnly = String(dateString).split('T')[0];
        const [y, m, d] = dateOnly.split('-').map(Number);
        const visited = new Date(y, m - 1, d);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const diffDays = Math.round((today - visited) / 86400000);
        if (diffDays < 0) {
            const n = Math.abs(diffDays);
            if (n === 1) return 'Mañana';
            if (n < 7) return `En ${n} días`;
            return 'Próximamente';
        }
        if (diffDays === 0) return 'Hoy';
        if (diffDays === 1) return 'Ayer';
        if (diffDays === 2) return 'Antier';
        if (diffDays < 7) return `Hace ${diffDays} días`;
        if (diffDays < 14) return 'Hace una semana';
        if (diffDays < 21) return 'Hace 2 semanas';
        if (diffDays < 28) return 'Hace 3 semanas';
        if (diffDays < 60) return 'Hace un mes';
        const months = Math.floor(diffDays / 30);
        if (months < 12) return `Hace ${months} meses`;
        return 'Más de un año';
    };

    // NOTA: El ordenamiento ahora se hace en el backend, por lo que este useEffect ya no es necesario
    // El endpoint ya devuelve los datos ordenados correctamente por review_date/postulation_date

    function calculateDateDifference(reviewDate) {
        const currentDate = new Date();
        const lastContactDate = new Date(reviewDate);
        const differenceInDays = Math.floor((currentDate - lastContactDate) / (1000 * 60 * 60 * 24));
        return differenceInDays;
    }

    function getEmojiImage(differenceInDays, status) {
        if (status === 'Cierre') return feliz;
        if (differenceInDays <= 7)  return feliz;
        if (differenceInDays <= 13) return serio;
        if (differenceInDays <= 21) return triste;
        return congelado; // cubre congelado (22-90) y dormido (>90)
    }

    function isDormido(differenceInDays, status) {
        return status !== 'Cierre' && differenceInDays > 90;
    }

    // const extractLeadIds = useCallback(() => {
    //     const ids = leads.map((lead) => lead.id);
    //     setLeadIds(ids);
    // }, [leads]);

    // useEffect(() => {
    //     extractLeadIds();
    // }, [leads, extractLeadIds]);

    const fetchDataForLead = useCallback(async (leadId) => {
        try {
            // Verificar si ya tenemos datos para este lead
            const existingData = leadTasksInfo.find(info => info.id === leadId);
            if (existingData) {
                return { success: true, leadId }; // Ya tenemos datos, no hacer la llamada
            }

            const response = await fetch(`${process.env.REACT_APP_API_URL || ""}/api/app/tasks?lead=${leadId}`);

            if (!response.ok) {
                // Solo logear errores de red, no errores de datos
                if (response.status !== 404) {
                    return { success: false, leadId, error: `Status ${response.status}` };
                }
                return { success: false, leadId, error: '404 Not Found' };
            }

            // Verificar si la respuesta es JSON válido
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                return { success: false, leadId, error: `Invalid content-type: ${contentType}` };
            }

            const tasks = await response.json();

            // Verificar que tasks sea un array válido
            if (!Array.isArray(tasks)) {
                return { success: false, leadId, error: 'Response is not an array' };
            }

            const openTasks = tasks.filter((task) => task.task_status === "Abierta");

            setLeadTasksInfo((prevInfo) => [
                ...prevInfo,
                {
                    id: leadId,
                    cantidad_tasks: openTasks.length,
                    taskIds: tasks.map(task => task.id),
                },
            ]);

            return { success: true, leadId };
        } catch (error) {
            // Solo logear errores de red reales, no errores de datos
            if (error.name !== 'TypeError' || !error.message.includes('JSON')) {
                return { success: false, leadId, error: error.message };
            }
            return { success: false, leadId, error: 'JSON parsing error' };
        }
    }, [leadTasksInfo, setLeadTasksInfo]);

    const isRequestingLead = useRef(new Set());
    // const apiCallsInProgress = useRef(0);
    // const loadingTimeoutRef = useRef(null);
    // const loadingStartTimeRef = useRef(null); // <-- Nuevo ref para guardar el tiempo de inicio
    const intentosLoadedRef = useRef(new Set()); // <-- Ref para controlar intentos ya cargados

    // const finishApiCall = useCallback(() => {
    //     apiCallsInProgress.current -= 1;

    //     if (apiCallsInProgress.current <= 0) {
    //         apiCallsInProgress.current = 0;

    //         // Limpiar timeout anterior si existe
    //         if (loadingTimeoutRef.current) {
    //             clearTimeout(loadingTimeoutRef.current);
    //         }

    //         const minLoadingTime = 10000; // 10 segundos
    //         const now = Date.now();
    //         const elapsed = loadingStartTimeRef.current ? now - loadingStartTimeRef.current : 0;
    //         const remaining = Math.max(minLoadingTime - elapsed, 0);

    //         loadingTimeoutRef.current = setTimeout(() => {
    //             setLoading(false);
    //             loadingTimeoutRef.current = null;
    //             loadingStartTimeRef.current = null;
    //         }, remaining);
    //     }
    // }, [setLoading]);

    // const startLoading = useCallback(() => {
    //     setLoading(true);
    //     loadingStartTimeRef.current = Date.now();
    //     if (loadingTimeoutRef.current) {
    //         clearTimeout(loadingTimeoutRef.current);
    //         loadingTimeoutRef.current = null;
    //     }
    // }, [setLoading]);

    // ELIMINADO: useEffect problemático de tareas que causaba bucle infinito
    // Las tareas se cargarán de forma lazy cuando se necesiten

    const calcularColorFondoTask = (tareas) => {
        if (tareas > 0) {
            return '#f96801';
        } else {
            return '#009419';
        }
    };

    const calcularColorFondoIntentos = (intentos) => {
        if (intentos >= 0 && intentos <= 2) {
            return { fondo: '#f96801', color: '#fff' };
        } else if (intentos >= 3 && intentos <= 5) {
            return { fondo: '#ffb822', color: '#212529' };
        } else {
            return { fondo: '#009419', color: '#fff' };
        }
    };

    const API_URL = `${process.env.REACT_APP_API_URL || ''}/api/notes/byLeadId`;

    // --- Declaración de fetchNumeroDeIntentos ANTES de cualquier useEffect que la use ---
    const fetchNumeroDeIntentos = useCallback(async (numeroDeLead) => {
        try {
            // Asegurar que isRequestingLead.current sea un Set válido
            if (!isRequestingLead.current || !isRequestingLead.current.has) {
                isRequestingLead.current = new Set();
            }

            if (isRequestingLead.current.has(numeroDeLead)) {
                // Esperar un poco y volver a intentar
                await new Promise(resolve => setTimeout(resolve, 100));
                if (numIntentByLead[numeroDeLead] !== undefined) {
                    return { success: true, leadId: numeroDeLead };
                }
                return { success: true, leadId: numeroDeLead };
            }
            if (numIntentByLead[numeroDeLead] !== undefined) {
                return { success: true, leadId: numeroDeLead };
            }

            isRequestingLead.current.add(numeroDeLead);
            const response = await fetch(`${API_URL}?lead=${numeroDeLead}&type_note=intento`);

            if (!response.ok) {
                if (response.status !== 404) {
                    return { success: false, leadId: numeroDeLead, error: `Status ${response.status}` };
                }
                return { success: false, leadId: numeroDeLead, error: '404 Not Found' };
            }

            const contentType = response.headers.get('content-type');

            if (!contentType || !contentType.includes('application/json')) {
                // Si no es JSON, probablemente es HTML (404 o error), tratamos como 0 intentos
                setNumIntentByLead((prevNumIntentByLead) => ({
                    ...prevNumIntentByLead,
                    [numeroDeLead]: 0,
                }));
                return { success: true, leadId: numeroDeLead };
            }

            const result = await response.json();

            if (!Array.isArray(result)) {
                return { success: false, leadId: numeroDeLead, error: 'Response is not an array' };
            }

            const length = result.length;

            setNumIntentByLead((prevNumIntentByLead) => ({
                ...prevNumIntentByLead,
                [numeroDeLead]: length,
            }));

            return { success: true, leadId: numeroDeLead };
        } catch (error) {
            if (error.name !== 'TypeError' || !error.message.includes('JSON')) {
                return { success: false, leadId: numeroDeLead, error: error.message };
            }
            return { success: false, leadId: numeroDeLead, error: 'JSON parsing error' };
        } finally {
            // Asegurar que isRequestingLead.current sea un Set válido antes de hacer delete
            if (isRequestingLead.current && isRequestingLead.current.delete) {
                isRequestingLead.current.delete(numeroDeLead);
            }
        }
    }, [setNumIntentByLead, numIntentByLead]);

    useEffect(() => {
        setValorSelect1(dataLead ? dataLead.age : 'No estoy seguro')
        setValorSelect2(dataLead ? dataLead.marital_status : 'Sin respuesta')
        setValorInput1(dataLead ? dataLead.city : 'Sin respuesta')
        setValorSelect3(dataLead ? dataLead.life_status : 'Sin respuesta')
        setValorSelect4(dataLead ? dataLead.gender : 'Sin respuesta')
        setValorSelect5(dataLead ? dataLead.purchase_reason : 'Sin respuesta')
        setValorSelect6(dataLead ? dataLead.purchase_time : 'No estoy seguro')
        setValorSelect7(dataLead ? dataLead.budget : 'Sin respuesta')
        setValorSelect8(dataLead ? dataLead.payment_type : 'Sin respuesta')
        setValorSelect9(dataLead ? dataLead.origin : 'Base de Datos')
        setValorSelect10(dataLead ? dataLead.contact_type : '')
        setValorSelect11(dataLead ? dataLead.tag : 'Sin etiqueta')
        setValorInput2(dataLead && dataLead.postulation_date ? dataLead.postulation_date.split('T')[0] : '')
        // setValorInput2(dataLead ? dataLead.postulation_date : '')
        setValorInput3(dataLead?.visited_date ? String(dataLead.visited_date).split('T')[0] : null)
    }, [
        dataLead,
        setValorInput1,
        setValorInput2,
        setValorInput3,
        setValorSelect1,
        setValorSelect10,
        setValorSelect11,
        setValorSelect2,
        setValorSelect3,
        setValorSelect4,
        setValorSelect5,
        setValorSelect6,
        setValorSelect7,
        setValorSelect8,
        setValorSelect9
    ]);

    // NOTA: La carga de intentos ahora se hace solo para leads visibles en paginatedLeads
    // Ver el useEffect que carga contadores de intentos más abajo

    // Limpiar el ref de intentos cargados y resetear página cuando cambie el proyecto
    useEffect(() => {
        intentosLoadedRef.current.clear();
        setPage(1);
        secureSetItem('currentPage', '1');
    }, [vacantCode]);

    // ELIMINADO: useEffect de intentos que causaba bucle infinito
    // Los intentos se cargarán de forma lazy cuando se necesiten

    const handleRecruiterChange = (selectedRecruiterId, leadId) => {
        const apiUrl = `${process.env.REACT_APP_API_URL || ""}/api/leads/${leadId}`;
        const recruiterValue = selectedRecruiterId === '' ? null : parseInt(selectedRecruiterId) || null;
        const now = new Date().toISOString();
        const newRecruiterUser = recruiterValue ? listaUsers?.find(u => u.id === recruiterValue) : null;
        const newRecruiterName = newRecruiterUser
            ? `${newRecruiterUser.first_name} ${newRecruiterUser.last_name || ''}`.trim()
            : 'Sin asignar';

        setAllLeadsFromBackend(prev => prev.map(l => l.id === leadId ? { ...l, recruiter: recruiterValue, review_date: now } : l));

        fetch(apiUrl, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCsrfToken() },
            body: JSON.stringify({ recruiter: recruiterValue, review_date: now }),
        })
            .then(response => {
                if (!response.ok) throw new Error('Error al actualizar recruiter');
                return response.json();
            })
            .then(() => {
                setLeads(prev => prev.map(l => l.id === leadId ? { ...l, recruiter: recruiterValue } : l));
                if (dataLead && dataLead.id === leadId) setDataLead({ ...dataLead, recruiter: recruiterValue });
            })
            .catch(error => {
                console.error('Error al actualizar recruiter:', error);
                setAllLeadsFromBackend(prev => prev.map(l => l.id === leadId ? { ...l, recruiter: null } : l));
            });
        postActionNote(leadId, 'Reasignación', `${nameMyUser} reasignó el contacto a ${newRecruiterName}`);
    };

    const handleTagChangeLocal = (e, leadId) => {
        const newTag = e.target.value;
        setAllLeadsFromBackend(prev => prev.map(l => l.id === leadId ? { ...l, tag: newTag } : l));
        setLeads(prev => (prev || []).map(l => l.id === leadId ? { ...l, tag: newTag } : l));
        fetch(`${process.env.REACT_APP_API_URL || ""}/api/leads/${leadId}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCsrfToken() },
            body: JSON.stringify({ tag: newTag }),
        })
        .then(async r => {
            if (!r.ok) console.error(`[tag PATCH] ${r.status}:`, await r.text());
        })
        .catch(err => console.error('[tag PATCH]', err));
        postActionNote(leadId, 'Cambio de estatus', `${nameMyUser} cambió el estatus del contacto a ${newTag}`);
    };

    const handleContractingStatusChangeLocal = (e, leadId) => {
        const newStatus = e.target.value;
        const now = new Date().toISOString();
        setAllLeadsFromBackend(prev => prev.map(l => l.id === leadId ? { ...l, contracting_status: newStatus, review_date: now } : l));
        setLeads(prev => (prev || []).map(l => l.id === leadId ? { ...l, contracting_status: newStatus } : l));
        fetch(`${process.env.REACT_APP_API_URL || ""}/api/leads/${leadId}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCsrfToken() },
            body: JSON.stringify({ contracting_status: newStatus, review_date: now }),
        })
        .then(async r => {
            if (!r.ok) console.error(`[etapa PATCH] ${r.status}:`, await r.text());
        })
        .catch(err => console.error('[etapa PATCH]', err));
        postActionNote(leadId, 'Cambio de etapa', `${nameMyUser} cambió la etapa a ${newStatus}`);
    };

    const touchReviewDate = (leadId) => {
        if (!leadId) return;
        const now = new Date().toISOString();
        setAllLeadsFromBackend(prev => prev.map(l => l.id === leadId ? { ...l, review_date: now } : l));
        fetch(`${process.env.REACT_APP_API_URL || ""}/api/leads/${leadId}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCsrfToken() },
            body: JSON.stringify({ review_date: now }),
        })
        .then(async r => {
            if (!r.ok) console.error(`[review_date PATCH] ${r.status}:`, await r.text());
        })
        .catch(err => console.error('[review_date PATCH]', err));
    };

    const handleVacantCodeChange = (newVacantCode, leadId) => {
        if (!newVacantCode || !leadId) return;
        fetch(`${process.env.REACT_APP_API_URL || ""}/api/leads/${leadId}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCsrfToken() },
            body: JSON.stringify({ vacant_code: newVacantCode }),
        })
        .then(async r => {
            if (r.ok) {
                setAllLeadsFromBackend(prev => prev.filter(l => l.id !== leadId));
                setLeads(prev => (prev || []).filter(l => l.id !== leadId));
                closeModalAccionesWeb();
                closeModalAcciones();
            } else {
                console.error(`[vacant_code PATCH] ${r.status}:`, await r.text());
            }
        })
        .catch(err => console.error('[vacant_code PATCH]', err));
    };

    const handleSaveVisited = (leadId) => {
        if (!leadId) return;
        const now = new Date().toISOString();
        setAllLeadsFromBackend(prev => prev.map(l =>
            l.id === leadId
                ? { ...l, contracting_status: 'Visita', review_date: now, visited_date: visited_date }
                : l
        ));
        setLeads(prev => (prev || []).map(l =>
            l.id === leadId
                ? { ...l, contracting_status: 'Visita', visited_date: visited_date }
                : l
        ));
        fetch(`${process.env.REACT_APP_API_URL || ""}/api/leads/${leadId}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCsrfToken() },
            body: JSON.stringify({ contracting_status: 'Visita', review_date: now }),
        })
        .then(async r => { if (!r.ok) console.error(`[visited PATCH] ${r.status}:`, await r.text()); })
        .catch(err => console.error('[visited PATCH]', err));
        const visitLabel = visited_date
            ? new Date(visited_date).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })
            : 'fecha pendiente';
        postActionNote(leadId, 'Fecha de visita', `${nameMyUser} agendó una visita para el ${visitLabel}`);
    };

    const activarEdicion = () => { setEnModoEdicion(true); }

    const activarEdicionInfo = () => { setEdicion(true); }

    const handleDeleteLead = async () => {
        if (!dataLead?.id) return;
        const confirmed = window.confirm(`¿Eliminar a ${dataLead.candidate_name}? Esta acción no se puede deshacer.`);
        if (!confirmed) return;
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/leads/${dataLead.id}`, {
                method: 'DELETE',
                headers: { 'X-CSRFToken': getCsrfToken() },
                credentials: 'include',
            });
            if (response.ok) {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error al eliminar el lead:', error);
        }
    };

    const cancelarEdicion = () => { setEnModoEdicion(false); }

    const cancelarEdicionInfo = () => { setEdicion(false); }

    const estiloSelect = {
        appearance: enModoEdicion ? 'auto' : 'none',
        border: enModoEdicion ? '1px solid #a1a1a186' : 'none'
    };

    const handleDateChange = (event) => {
        const inputDate = event.target.value;

        const formattedDate = formatInputDate(inputDate);

        setValorInput2(formattedDate);
    };

    const handleVisitedDateChange = (event) => {
        const date = new Date(event.target.value);
        date.setDate(date.getDate() + 1);
        setValorInput3(formatInputDate(date));
    };

    const formatInputDate = (inputDate) => {
        const dateObject = new Date(inputDate);

        const year = dateObject.getFullYear();
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObject.getDate().toString().padStart(2, '0');
        const hours = dateObject.getHours().toString().padStart(2, '0');
        const minutes = dateObject.getMinutes().toString().padStart(2, '0');
        const seconds = dateObject.getSeconds().toString().padStart(2, '0')
        const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        return formattedDate;
    };

    function formatDateToLongDate(dateString) {
        if (!dateString) {
            return 'Fecha inválida';
        }
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString('es-MX', options);
    }

    const dateFormatIntento = (fechaOriginal) => {
        const fecha = new Date(fechaOriginal);
        return format(fecha, 'dd/MM/yyyy');
    }

    const scrollRef = useRef(null);

    useEffect(() => {
        if ((optionContac === 'Intentos' || 'WhatsApp') && scrollRef.current) {
            scrollRef.current.scrollIntoView();
        }
    }, [optionContac, intentosV3]);


    const resetInputs = () => {
        setNewTitle('');
        setNewObservation('');
    };

    useEffect(() => {
        if (intentosV3 && Array.isArray(intentosV3)) {
            intentosV3.forEach(intento => {
                if (intento.user === Id) {
                    setMyUser(Id);
                } else {
                    setNumeroUser(intento.user);
                }
            });
        }
    }, [Id, intentosV3, setMyUser, setNumeroUser]);

    const handleSelectChange = (event) => {
        setTag(event.target.value);
    };

    const handleSelectOrigin = (event) => {
        setOriginUrl(event.target.value);
    };

    const handleSelectSeguimiento = (event) => {
        setSeguimiento(event.target.value);
        setSearchParams(p => { p.set('seguimiento', event.target.value); return p; }, { replace: true });
    };

    const handleSelectPeriodo = (event) => {
        const value = event.target.value;
        setPeriodo(value);
        if (value !== 'otro') {
            setSearchParams(p => { p.set('periodo', value); return p; }, { replace: true });
        }
        if (value === 'otro') {
            if (window.innerWidth <= 780) {
                // openModalFilterPeriodMovil();
            } else {
                openModalFilterPeriod();
            }
        }
    };

    const handleSelectVisited = (event) => {
        setVisited(event.target.value);
    };

    const handleSelectAsesor = (event) => {
        setRecruiterId(event.target.value);
    };

    const resetAllFilters = () => {
        setStageSelected(1);
        setPeriodo("00");
        setSeguimiento("contactos");
        setOriginUrl("todos");
        setVisited("Todos");
        setRecruiterId("");
        setTag("todas");
        setFechaInicio(null);
        setFechaFin(null);
        setEmojiFilter(null);
        setPage(1);
        setSearchParams({}, { replace: true });
    };

    const handleOpcionChange = (event) => {
        setNewObservation(event.target.value);
    };

    const handleDate2Change = (e) => {
        const selectedDate = e.target.value;
        const adjustedDate = new Date(selectedDate + 'T00:00:00Z');
        const formattedDate = formatDate(adjustedDate);
        setExpiration(formattedDate);
    };

    const formatDate = (dateObject) => {
        const year = dateObject.getUTCFullYear();
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0');
        const day = String(dateObject.getUTCDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const handleNombreChange = (e) => {
        setModalCandidateName(e.target.value);
    };

    const handleCorreoChange = (e) => {
        setModalEmail(e.target.value);
    };

    const handleTelefonoChange = (e) => {
        const value = e.target.value;
        // Limit to 10 characters
        if (value.length <= 10) {
            setModalPhoneNumber(value);
        }
    };


    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    const handleEdadChange = (e) => {
        setModalAge(e.target.value);
    };

    const handleCivilChange = (e) => {
        setModalMaritalStatus(e.target.value);
    };

    const handleCiudadChange = (e) => {
        setModalCity(e.target.value);
    };

    const handleLifeChange = (e) => {
        setModalLifeStatus(e.target.value);
    };

    const handleGeneroChange = (e) => {
        setModalGender(e.target.value);
    };

    const handleReasonChange = (e) => {
        setModalPurchaseReason(e.target.value);
    };

    const handleCompraChange = (e) => {
        setModalPurchaseTime(e.target.value);
    };

    const handlePresupuestoChange = (e) => {
        setModalBudget(e.target.value);
    };

    const handleTipoPagoChange = (e) => {
        setModalPaymentType(e.target.value);
    };

    const handleTipoChange = (e) => {
        setModalContactType(e.target.value);
    };

    const handleOrigenChange = (e) => {
        setModalOrigin(e.target.value);
    };

    const handleEstatusChange = (e) => {
        setModalContractingStatus(e.target.value);
    };

    const filtrarLeadsPorFecha = () => {
        if (!fechaInicio || !fechaFin) {
            return;
        }

        const fechaInicioLuxon = DateTime.fromISO(fechaInicio.toISOString(), { zone: 'America/Mexico_City' });
        const fechaFinLuxon = DateTime.fromISO(fechaFin.toISOString(), { zone: 'America/Mexico_City' });

        const leadsFiltrados = leads.filter((lead) => {
            const fechaCreacion = DateTime.fromISO(lead.created_date, { zone: 'America/Mexico_City' });

            return fechaCreacion >= fechaInicioLuxon && fechaCreacion <= fechaFinLuxon;
        });

        setLeads(leadsFiltrados);
    };

    useEffect(() => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        setCurrentDate(formattedDate);
    }, []);

    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMore(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setNameLead(dataLead ? dataLead.candidate_name : "")
        setEmailLead(dataLead ? dataLead.email : "")
        setPhoneLead(dataLead ? dataLead.phone_number : "")
    }, [dataLead]);

    const primeraLetraLead = typeof candidate_name === 'string' ? candidate_name.substring(0, 1) : '...';

    useEffect(() => {
        setCandidate_Name(candidate_name)
        setEmail(email)
        setPhone_Number(phone_number)
    }, [candidate_name, setCandidate_Name, email, setEmail, setPhone_Number, phone_number])

    // **********Logica de programacion Movil**********

    const [mostrarDivArray, setMostrarDivArray] = useState(() => {
        return Array((filteredContacts && Array.isArray(filteredContacts)) ? filteredContacts.length : 0).fill(false);
    });

    const toggleDiv = (index) => {
        if (!mostrarDivArray || !Array.isArray(mostrarDivArray)) return;
        const newMostrarDivArray = [...mostrarDivArray];
        if (index >= 0 && index < newMostrarDivArray.length) {
            newMostrarDivArray[index] = !newMostrarDivArray[index];
            setMostrarDivArray(newMostrarDivArray);
        }
    };

    const calcularColorFondo = (fecha, status) => {
        const fechaActual = moment();
        const fechaDada = moment(fecha);

        const diferenciaMeses = fechaDada.diff(fechaActual, 'months');

        if (diferenciaMeses < 0 && status !== 'Cierre') {
            return '#f96801';
        }
    };

    // Estados de paginación - Recuperar página guardada en localStorage
    const [page, setPage] = useState(() => {
        const savedPage = secureGetItem('currentPage');
        return savedPage ? parseInt(savedPage) : 1;
    });
    const [allLeadsFromBackend, setAllLeadsFromBackend] = useState([]); // Todos los leads del backend
    const [emojiFilter, setEmojiFilter] = useState(null); // null | 'feliz' | 'serio' | 'triste' | 'congelado' | 'dormido'
    const [paginatedLeads, setPaginatedLeads] = useState([]); // Leads de la página actual
    const [totalLeads, setTotalLeads] = useState(0);
    const [isLoadingPage, setIsLoadingPage] = useState(false);

    // Guardar página actual en localStorage cuando cambie
    useEffect(() => {
        secureSetItem('currentPage', page.toString());
    }, [page]);

    // Resetear página cuando cambien los filtros o la búsqueda (pero no durante la inicialización)
    const isInitialMount = useRef(true);
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            setPage(1);
        }
    }, [tagUrl, originUrl, seguimiento, periodo, visited, recruiter_id, searchTerm, fechaInicio, fechaFin]);

    // Actualizar mostrarDivArray cuando cambien los leads paginados
    useEffect(() => {
        if (paginatedLeads && Array.isArray(paginatedLeads)) {
            setMostrarDivArray(Array(paginatedLeads.length).fill(false));
        } else {
            setMostrarDivArray([]);
        }
    }, [paginatedLeads]);

    // Calcular dinámicamente cuántos elementos caben y la altura de cada fila
    const calculateTableLayout = () => {
        const viewportHeight = window.innerHeight;
        const containerHeight = (viewportHeight * 0.95) - 150; // calc(95vh - 150px)
        const headerHeight = 53;
        const availableHeight = containerHeight - headerHeight;

        // Determinar cuántos elementos mostrar según el tamaño de pantalla
        let targetItems;
        if (window.innerWidth <= 780) {
            // Pantallas pequeñas: 5-6 elementos
            targetItems = Math.max(5, Math.min(6, Math.floor(availableHeight / 60)));
        } else {
            // Pantallas grandes: 7-9 elementos
            targetItems = Math.max(7, Math.min(9, Math.floor(availableHeight / 60)));
        }

        // Calcular la altura dinámica de cada fila para llenar completamente el espacio
        // Restar 1px por cada fila para el borde inferior
        const borderHeight = targetItems * 1; // 1px de borde por fila
        const dynamicRowHeight = Math.floor((availableHeight - borderHeight) / targetItems);

        return {
            itemsPerPage: targetItems,
            rowHeight: dynamicRowHeight
        };
    };

    const initialLayout = calculateTableLayout();
    const [itemsPerPage, setItemsPerPage] = useState(initialLayout.itemsPerPage);
    const [rowHeight, setRowHeight] = useState(initialLayout.rowHeight);

    // Función para construir la URL del endpoint (solo vacant_code y limit)
    // Todos los demás filtros se hacen en el frontend
    const buildLeadsUrl = useCallback(() => {
        const BASE_URL = process.env.REACT_APP_API_URL || '';
        let url = `${BASE_URL}/api/leads?vacant_code=${encodeURIComponent(vacantCode)}&limit=999999`;
        return url;
    }, [vacantCode]);

    // Función para cargar TODOS los leads del backend
    const fetchAllLeadsFromBackend = useCallback(async () => {
        if (!vacantCode) return;

        try {
            setIsLoadingPage(true);
            const url = buildLeadsUrl();
            const response = await fetch(url);

            if (response.ok) {
                const allLeads = await response.json();
                if (Array.isArray(allLeads)) {
                    setAllLeadsFromBackend(allLeads);
                } else {
                    setAllLeadsFromBackend([]);
                }
            } else {
                setAllLeadsFromBackend([]);
            }
        } catch (error) {
            console.error('Error cargando leads:', error);
            setAllLeadsFromBackend([]);
        } finally {
            setIsLoadingPage(false);
        }
    }, [vacantCode, buildLeadsUrl]);

    // Función para determinar el tipo de búsqueda
    const getSearchType = useCallback((searchValue) => {
        if (!searchValue) return 'name';
        if (searchValue.includes('@')) return 'email';
        if (/\d/.test(searchValue)) return 'phone';
        return 'name';
    }, []);

    // Función para filtrar por periodo (en el frontend)
    const filterLeadsByPeriodo = useCallback((leads, periodoValue) => {
        if (!periodoValue || periodoValue === '00') {
            return leads; // Sin filtro de periodo
        }

        const now = moment();

        return leads.filter((lead) => {
            const fechaCreacion = moment(lead.created_date);
            const diasDiferencia = now.diff(fechaCreacion, 'days');

            switch (periodoValue) {
                case 'semana':
                    return diasDiferencia <= 7;
                case '15_dias':
                    return diasDiferencia <= 15;
                case '30_dias':
                    return diasDiferencia <= 30;
                case '90_dias':
                    return diasDiferencia <= 90;
                case 'otro':
                    // El filtro por fechas personalizadas
                    if (fechaInicio && fechaFin) {
                        const fechaInicioMoment = moment(fechaInicio).startOf('day');
                        const fechaFinMoment = moment(fechaFin).endOf('day');
                        return fechaCreacion.isBetween(fechaInicioMoment, fechaFinMoment, null, '[]');
                    }
                    return true;
                default:
                    return true;
            }
        });
    }, [fechaInicio, fechaFin]);

    // Filtrar por etiqueta
    const filterLeadsByTag = useCallback((leads, tagValue) => {
        if (!tagValue || tagValue === 'todas') {
            return leads; // Sin filtro, mostrar todos
        }
        if (tagValue === '' || tagValue === 'Sin etiqueta') {
            // Filtrar leads SIN etiqueta
            return leads.filter(lead => !lead.tag || lead.tag === '' || lead.tag === null);
        }
        // Filtrar por etiqueta específica
        return leads.filter(lead => lead.tag === tagValue);
    }, []);

    // Filtrar por origen (agrupando variantes del mismo canal)
    const filterLeadsByOrigin = useCallback((leads, originValue) => {
        if (!originValue || originValue === 'todos') return leads;
        const groups = {
            'Base_Datos':            ['Base_Datos', 'Base Datos', 'Base de Datos BBR'],
            'Facebook':              ['Facebook', 'Facebook_Organic', 'Facebook_Mobile_Feed', 'Facebook_Instant_Articles', 'Facebook_Marketplace'],
            'Facebook_Desktop_Feed': ['Facebook_Desktop_Feed', 'Facebook Ads', 'Facebook Forms'],
            'Google':                ['Google', 'Google_Organic'],
            'Google Ads':            ['Google Ads', 'Google_ads'],
            'Instagram':             ['Instagram', 'Instagram_Explore', 'Instagram_Feed'],
            'Instagram Ads':         ['Instagram Ads'],
            'LinkedIn':              ['LinkedIn', 'Linkedin', 'linkedin'],
            'Página web':            ['Página web', 'Pagina web', 'Sitio web Forms'],
            'Redes sociales':        ['Redes sociales', 'Redes Sociales'],
            'Broker':                ['Broker', 'Broker o Asesor Externo', 'Asesores Externos'],
            'Espectacular':          ['Espectacular', 'Espectacular South Hill (Carretera Celaya)', 'Lonas'],
            'Periodico':             ['Periodico', 'Periódico'],
            'Referidos':             ['Referidos', 'RECOMENDACIï¿½N'],
            'Señaletica':            ['Señaletica', 'Señalética'],
            'Telefono':              ['Telefono', 'Teléfono'],
        };
        const matchValues = groups[originValue] || [originValue];
        return leads.filter(lead => matchValues.includes(lead.origin));
    }, []);

    // Filtrar por seguimiento
    const filterLeadsBySeguimiento = useCallback((leads, seguimientoValue) => {
        if (!seguimientoValue || seguimientoValue === 'contactos') {
            return leads;
        }
        if (seguimientoValue === 'descartados') {
            return leads.filter(lead => lead.discard === true);
        }
        if (seguimientoValue === 'seguimiento') {
            return leads.filter(lead => lead.discard === false || lead.discard === null);
        }
        return leads;
    }, []);

    // Filtrar por visitó desarrollo
    const filterLeadsByVisited = useCallback((leads, visitedValue) => {
        if (!visitedValue || visitedValue === 'Todos' || visitedValue === 'todos') {
            return leads;
        }
        if (visitedValue === 'true') {
            return leads.filter(lead => lead.visited_date !== null && lead.visited_date !== undefined);
        }
        if (visitedValue === 'false') {
            return leads.filter(lead => lead.visited_date === null || lead.visited_date === undefined);
        }
        return leads;
    }, []);

    // Filtrar por asesor
    const filterLeadsByRecruiter = useCallback((leads, recruiterValue) => {
        if (!recruiterValue || recruiterValue === '') {
            return leads;
        }
        if (recruiterValue === 'null') {
            return leads.filter(lead => lead.recruiter === null || lead.recruiter === undefined);
        }
        return leads.filter(lead => lead.recruiter === parseInt(recruiterValue));
    }, []);

    // Filtrar leads por búsqueda en el FRONTEND
    const filterLeadsBySearch = useCallback((leads, searchValue) => {
        if (!searchValue || searchValue.trim() === '') {
            return leads;
        }

        const searchType = getSearchType(searchValue);
        const lowerSearchTerm = searchValue.toLowerCase();

        return leads.filter((item) => {
            switch (searchType) {
                case 'email':
                    return item.email?.toLowerCase().includes(lowerSearchTerm);
                case 'phone':
                    return item.phone_number?.toLowerCase().includes(lowerSearchTerm);
                case 'name':
                default:
                    return item.candidate_name?.toLowerCase().includes(lowerSearchTerm);
            }
        });
    }, [getSearchType]);

    // Función para obtener el valor de contracting_status basado en stageSelected
    const getContractingStatusByStage = (stage) => {
        switch (stage) {
            case 1: return null; // Todos los contactos (sin filtrar por etapa)
            case 2: return 'Calificado';
            case 3: return 'Cita';
            case 4: return 'Visita';
            case 5: return 'Potencial';
            case 6: return 'Cierre';
            default: return null;
        }
    };

    // Función para filtrar leads por etapa
    const filterLeadsByStage = useCallback((leads, stage) => {
        if (stage === 1) {
            // Mostrar todos los leads
            return leads;
        }

        const contractingStatus = getContractingStatusByStage(stage);
        return leads.filter(item => item.contracting_status === contractingStatus);
    }, []);

    const filterLeadsByEmoji = useCallback((leads, filter) => {
        if (!filter) return leads;
        return leads.filter(lead => {
            const diff = calculateDateDifference(lead.review_date);
            if (filter === 'feliz')     return diff <= 7;
            if (filter === 'serio')     return diff >= 8  && diff <= 13;
            if (filter === 'triste')    return diff >= 14 && diff <= 21;
            if (filter === 'congelado') return diff >= 22 && diff <= 90;
            if (filter === 'dormido')   return diff > 90;
            return true;
        });
    }, []);

    const emojiCounts = useMemo(() => {
        const base = allLeadsFromBackend;
        const count = (fn) => base.filter(fn).length;
        return {
            feliz:     count(l => calculateDateDifference(l.review_date) <= 7),
            serio:     count(l => { const d = calculateDateDifference(l.review_date); return d >= 8  && d <= 13; }),
            triste:    count(l => { const d = calculateDateDifference(l.review_date); return d >= 14 && d <= 21; }),
            congelado: count(l => { const d = calculateDateDifference(l.review_date); return d >= 22 && d <= 90; }),
            dormido:   count(l => calculateDateDifference(l.review_date) > 90),
            total:     base.length,
        };
    }, [allLeadsFromBackend]);

    // Calcular indicadores basándose en TODOS los leads filtrados (sin filtrar por etapa)
    const calculateIndicators = useCallback((leads) => {
        setTotalLength(leads.length);
        const calificados = leads.filter(item => item.contracting_status === 'Calificado').length;
        setCalificadoLength(calificados);
        const citas = leads.filter(item => item.contracting_status === 'Cita').length;
        setCitaLength(citas);
        const visitas = leads.filter(item => item.contracting_status === 'Visita').length;
        setVisitaLength(visitas);
        const potenciales = leads.filter(item => item.contracting_status === 'Potencial').length;
        setPotencialLength(potenciales);
        const cierres = leads.filter(item => item.contracting_status === 'Cierre').length;
        setCierreLength(cierres);
    }, []);

    // Calcular leads filtrados y paginados (aplica TODOS los filtros en el frontend)
    const getFilteredAndPaginatedLeads = useCallback(() => {
        let filtered = allLeadsFromBackend;

        // 1. Filtrar por etiqueta
        filtered = filterLeadsByTag(filtered, tagUrl);

        // 2. Filtrar por origen
        filtered = filterLeadsByOrigin(filtered, originUrl);

        // 3. Filtrar por visitó
        filtered = filterLeadsByVisited(filtered, visited);

        // 4. Filtrar por asesor/recruiter — Asesor siempre ve solo sus propios contactos
        const effectiveRecruiterId = rolActivo === 'Asesor' ? String(Id) : recruiter_id;
        filtered = filterLeadsByRecruiter(filtered, effectiveRecruiterId);

        // 5. Filtrar por periodo
        filtered = filterLeadsByPeriodo(filtered, periodo);

        // 6. Filtrar por búsqueda
        filtered = filterLeadsBySearch(filtered, searchTerm);

        // 7. Filtrar por etapa (stageSelected)
        filtered = filterLeadsByStage(filtered, stageSelected);

        // 8. Filtrar por seguimiento (DESPUÉS del filtro por etapa)
        filtered = filterLeadsBySeguimiento(filtered, seguimiento);

        // 9. Filtrar por emoji (review_date delta)
        filtered = filterLeadsByEmoji(filtered, emojiFilter);

        // 10. Actualizar total de leads filtrados
        setTotalLeads(filtered.length);

        // 11. Paginar
        const startIdx = (page - 1) * itemsPerPage;
        const endIdx = startIdx + itemsPerPage;
        const paginated = filtered.slice(startIdx, endIdx);

        return paginated;
    }, [
        allLeadsFromBackend,
        tagUrl,
        originUrl,
        seguimiento,
        visited,
        recruiter_id,
        periodo,
        searchTerm,
        stageSelected,
        page,
        itemsPerPage,
        filterLeadsByTag,
        filterLeadsByOrigin,
        filterLeadsBySeguimiento,
        filterLeadsByVisited,
        filterLeadsByRecruiter,
        filterLeadsByPeriodo,
        filterLeadsBySearch,
        filterLeadsByStage,
        filterLeadsByEmoji,
        emojiFilter,
    ]);

    // Cargar TODOS los leads del backend solo cuando cambie el proyecto
    // En el primer montaje, restaurar filtros desde URL params; en cambios de proyecto, resetear
    useEffect(() => {
        if (vacantCode) {
            if (!initializedFromUrl.current) {
                initializedFromUrl.current = true;
                const stage = searchParams.get('stage');
                const per = searchParams.get('periodo');
                const seg = searchParams.get('seguimiento');
                setStageSelected(stage ? parseInt(stage) : 1);
                setPeriodo(per || '00');
                setSeguimiento(seg || 'seguimiento');
                setPage(1);
            } else {
                resetAllFilters();
            }
            fetchAllLeadsFromBackend();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vacantCode]);

    // Calcular indicadores cuando cambien los leads o filtros (pero NO cuando cambie el indicador seleccionado)
    useEffect(() => {
        if (allLeadsFromBackend.length > 0) {
            let filtered = allLeadsFromBackend;

            // Aplicar todos los filtros excepto el filtro por etapa
            filtered = filterLeadsByTag(filtered, tagUrl);
            filtered = filterLeadsByOrigin(filtered, originUrl);
            filtered = filterLeadsByVisited(filtered, visited);
            filtered = filterLeadsByRecruiter(filtered, recruiter_id);
            filtered = filterLeadsByPeriodo(filtered, periodo);
            filtered = filterLeadsBySearch(filtered, searchTerm);
            filtered = filterLeadsBySeguimiento(filtered, seguimiento);

            // Calcular indicadores basándose en los leads filtrados
            calculateIndicators(filtered);
        } else {
            // Resetear indicadores si no hay leads
            setTotalLength(0);
            setCalificadoLength(0);
            setCitaLength(0);
            setVisitaLength(0);
            setPotencialLength(0);
            setCierreLength(0);
        }
    }, [
        allLeadsFromBackend,
        tagUrl,
        originUrl,
        seguimiento,
        visited,
        recruiter_id,
        periodo,
        searchTerm,
        calculateIndicators,
        filterLeadsByTag,
        filterLeadsByOrigin,
        filterLeadsBySeguimiento,
        filterLeadsByVisited,
        filterLeadsByRecruiter,
        filterLeadsByPeriodo,
        filterLeadsBySearch
    ]);

    // Actualizar leads paginados cuando cambien: CUALQUIER filtro, búsqueda, página o allLeadsFromBackend
    useEffect(() => {
        if (allLeadsFromBackend.length > 0 && itemsPerPage > 0) {
            const paginated = getFilteredAndPaginatedLeads();
            setPaginatedLeads(paginated);
        } else if (allLeadsFromBackend.length === 0) {
            setPaginatedLeads([]);
            setTotalLeads(0);
        }
    }, [
        allLeadsFromBackend,
        tagUrl,
        originUrl,
        seguimiento,
        visited,
        recruiter_id,
        periodo,
        fechaInicio,
        fechaFin,
        searchTerm,
        stageSelected,
        page,
        itemsPerPage,
        getFilteredAndPaginatedLeads
    ]);

    // Actualizar layout cuando cambie el tamaño de la ventana
    useEffect(() => {
        const handleResize = () => {
            const newLayout = calculateTableLayout();
            setItemsPerPage(newLayout.itemsPerPage);
            setRowHeight(newLayout.rowHeight);
            // Resetear a la primera página cuando cambie el layout
            setPage(1);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // ELIMINADO: Los contadores de intentos y tareas ahora vienen directamente del endpoint
    // en las propiedades lead.contact_attempts y lead.open_tasks

    // Función helper para obtener los contactos paginados
    const getFilteredContacts = () => {
        return paginatedLeads || [];
    };

    const startIndex = 0; // Siempre empezamos desde 0 ya que los datos vienen paginados
    const endIndex = paginatedLeads.length; // Mostramos todos los datos recibidos

    // Close modal when shouldCloseModal is true (successful API call)
    useEffect(() => {
        if (shouldCloseModal) {
            // Close both desktop and mobile modals
            closeModal();
            closeModalAddMovil();

            // Reset all form values to their default values
            setModalCandidateName('');
            setModalEmail('');
            setModalPhoneNumber('');
            setModalAge('');
            setModalMaritalStatus('');
            setModalCity('');
            setModalLifeStatus('');
            setModalGender('');
            setModalPurchaseReason('');
            setModalPurchaseTime('');
            setModalBudget('');
            setModalPaymentType('');
            setModalContactType('');
            setModalOrigin('');
            setModalContractingStatus('');

            // Reset task-related fields
            setTitle('');
            setDescription('');
            setExpiration(undefined);
            setType_Task('');
            setNewTitle('');
            setNewObservation('');

            // Reset error fields
            setCandidateNameError('');
            setEmailError('');
            setPhoneNumberError('');
            setAgeError('');
            setCityError('');
            setGenderError('');
            setContactTypeError('');
            setOriginError('');
            setContractingStatusError('');
            // setApiErrorMessage(''); // Ya no se usa, se usa el del contexto

            // Actualizar la tabla después de agregar un lead exitosamente
            fetchAllLeadsFromBackend();

            // Reset shouldCloseModal after closing
            setTimeout(() => {
                if (typeof setShouldCloseModal === 'function') {
                    setShouldCloseModal(false);
                }
            }, 100);
        }
    }, [shouldCloseModal, fetchAllLeadsFromBackend]);

    const clearSearch = () => {
        // Cancelar cualquier búsqueda pendiente
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        setLocalSearchTerm("");
        setSearchTerm("");
        setPage(1);
    }

    // Función para manejar el cambio de página
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    // Función para generar los números de página
    const generatePageNumbers = () => {
        const totalPages = Math.ceil(totalLeads / itemsPerPage) || 1;
        const currentPage = page;
        const pages = [];

        if (totalPages <= 7) {
            // Si hay 7 páginas o menos, mostrar todas
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Si hay más de 7 páginas, mostrar con ellipsis
            if (currentPage <= 4) {
                // Páginas iniciales
                for (let i = 1; i <= 5; i++) {
                    pages.push(i);
                }
                pages.push('...');
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 3) {
                // Páginas finales
                pages.push(1);
                pages.push('...');
                for (let i = totalPages - 4; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                // Páginas intermedias
                pages.push(1);
                pages.push('...');
                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                    pages.push(i);
                }
                pages.push('...');
                pages.push(totalPages);
            }
        }

        return pages;
    };

    // Cleanup del timeout cuando el componente se desmonta
    // useEffect(() => {
    //     return () => {
    //         if (loadingTimeoutRef.current) {
    //             clearTimeout(loadingTimeoutRef.current);
    //         }
    //     };
    // }, []);

    return (
        loading ? <Loading /> :
            <>
                <PageBase />
                {isLoadingPage && <LoadingOverlay />}
                {allLeadsFromBackend.length > 0 ? (<div className="main-content">
                    <div className="margenV3-contactos">
                        <div className="cointainerV3-inidicadores">
                            <div onClick={() => {
                                handleButtonClickIndicadores(1)
                                setStageSelected(1)
                                setSearchParams(p => { p.set('stage', '1'); return p; }, { replace: true });
                            }} style={{
                                border: stageSelected === 1 ? '1px solid #df2d61' : '1px solid #a1a1a186'
                            }}>
                                <span>{totalLength}</span>
                                <label>Contactos</label>
                            </div>
                            <div onClick={() => {
                                handleButtonClickIndicadores(2)
                                setStageSelected(2)
                                setSearchParams(p => { p.set('stage', '2'); return p; }, { replace: true });
                            }} style={{
                                border: stageSelected === 2 ? '1px solid #df2d61' : '1px solid #a1a1a186'
                            }}>
                                <span>{calificadoLength}</span>
                                <label>Calificados</label>
                            </div>
                            <div onClick={() => {
                                handleButtonClickIndicadores(3)
                                setStageSelected(3)
                                setSearchParams(p => { p.set('stage', '3'); return p; }, { replace: true });
                            }} style={{
                                border: stageSelected === 3 ? '1px solid #df2d61' : '1px solid #a1a1a186'
                            }}>
                                <span>{citaLength}</span>
                                <label>Citas</label>
                            </div>
                            <div onClick={() => {
                                handleButtonClickIndicadores(4)
                                setStageSelected(4)
                                setSearchParams(p => { p.set('stage', '4'); return p; }, { replace: true });
                            }} style={{
                                border: stageSelected === 4 ? '1px solid #df2d61' : '1px solid #a1a1a186'
                            }}>
                                <span>{visitaLength}</span>
                                <label>Visitas</label>
                            </div>
                            <div onClick={() => {
                                handleButtonClickIndicadores(5)
                                setStageSelected(5)
                                setSearchParams(p => { p.set('stage', '5'); return p; }, { replace: true });
                            }} style={{
                                border: stageSelected === 5 ? '1px solid #df2d61' : '1px solid #a1a1a186'
                            }}>
                                <span>{potencialLength}</span>
                                <label>Potenciales</label>
                            </div>
                            <div onClick={() => {
                                handleButtonClickIndicadores(6)
                                setStageSelected(6)
                                setSearchParams(p => { p.set('stage', '6'); return p; }, { replace: true });
                            }} style={{
                                border: stageSelected === 6 ? '1px solid #df2d61' : '1px solid #a1a1a186'
                            }}>
                                <span>{cierreLength}</span>
                                <label>Cierres</label>
                            </div>
                        </div>
                        <div style={{
                            display: gridLayout ? 'grid' : 'block',
                            gridTemplateColumns: gridLayout ? 'repeat(12, 1fr)' : 'none',
                        }}>
                            <div className="table-body-v3" style={{
                                gridColumn: gridColumn2 ? 'span 3' : '',
                                borderRadius: borderRadius,
                                WebkitScrollbar: {
                                    width: hideScrollbar ? '0px' : 'auto',
                                    height: hideScrollbar ? 'calc(100% - 60px)' : '0',
                                }
                            }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th ref={menuRef} className="cuadro-busqueda" style={{ gridColumn: gridColumn, borderRight: borderLeft }}>
                                                <section>
                                                    <img src={lupaSearch} alt="" />
                                                    <input
                                                        type="text"
                                                        placeholder="Busca por nombre, correo o teléfono"
                                                        value={localSearchTerm}
                                                        onChange={handleSearch}
                                                        style={{ width: gridColumn === 'span 3' ? '100%' : '80%' }}
                                                    />
                                                </section>
                                                <div className="tooltip-container">
                                                    <button
                                                        className="tres-puntitos-button"
                                                        onClick={() => { handleMore() }}
                                                        onMouseEnter={() => setIsTresPuntitosHovered(true)}
                                                        onMouseLeave={() => setIsTresPuntitosHovered(false)}
                                                    >
                                                        <img src={isTresPuntitosHovered ? tresPuntitosPink : tresPuntitos} alt="" />
                                                    </button>
                                                    <div className="tooltip tooltip-bottom">Opciones</div>
                                                </div>
                                            </th>
                                            <div className="cuadro-row9" style={{ display: divDisplay }}>
                                                {tableB === true && <>
                                                    <th>Id</th>
                                                    <th>Afinidad</th>
                                                    <th>Estatus</th>
                                                    <th>Etapa</th>
                                                    <th>Responsable</th>
                                                    <th>Acciones</th>
                                                    <th>Intentos</th>
                                                    <th>Tareas</th>
                                                    <th>Fecha de registro</th>
                                                    <th>Próximo contacto</th>
                                                    <th>Visitó</th>
                                                </>}
                                            </div>
                                        </tr>
                                    </thead>
                                    {more && (<div className="more-v3">
                                        <label onClick={() => { openModal(); setMore(false); }}><img src={addBlack} alt="" />Agregar contacto</label>
                                        <label onClick={() => { openModalDownLeadWeb(); setMore(false); }}><img src={downloadBlack} alt="" />Descargar contactos</label>
                                        <label onClick={() => { openModalFiltros(); setMore(false); }}><img src={filterBlack} alt="" />Filtrar contactos</label>
                                    </div>)}
                                    <tbody style={{ '--dynamic-row-height': `${rowHeight}px` }}>
                                        {getFilteredContacts().length === 0 ? (
                                            <tr>
                                                <td colSpan="12" style={{ textAlign: 'center' }}>
                                                    {isLoadingPage ? '' : 'No hay contactos para mostrar'}
                                                </td>
                                            </tr>
                                        ) : (
                                            getFilteredContacts().slice(startIndex, endIndex).map((lead) => {
                                                return (
                                                    <tr key={lead.id}>
                                                        <td className="cuadro-nombre" onClick={() => {
                                                            const panelAbierto = !tableB;
                                                            const mismoContacto = selectedCell === lead.id;
                                                            setIdLead(lead.id)
                                                            if (!panelAbierto || mismoContacto) cambiarEstado()
                                                            setSelectedCell(lead.id)
                                                        }} style={{
                                                            gridColumn: gridColumn,
                                                            borderRight: borderLeft,
                                                            backgroundColor: selectedCell === lead.id ? '#e8e8e8' : '#fff'
                                                        }}>
                                                            <div id="origin">
                                                                <img src={getOriginImage(lead.origin)} alt={lead.origin} title={lead.origin} />
                                                                <span>{getOriginLabel(lead.origin)}</span>
                                                            </div>
                                                            <section>
                                                                <label>
                                                                    {lead.candidate_name}
                                                                </label>
                                                                <span>{formatearFecha(lead.review_date)}</span>
                                                            </section>
                                                            {isDormido(calculateDateDifference(lead.review_date), lead.contracting_status)
                                                                ? <span id="emoji" style={{ fontSize: '22px', lineHeight: 1 }}>😴</span>
                                                                : <img id="emoji" src={getEmojiImage(calculateDateDifference(lead.review_date), lead.contracting_status)} alt="" />
                                                            }
                                                        </td>
                                                        <div className="cuadro-row9" style={{ display: divDisplay }}>
                                                            {tableB === true && <>
                                                                <td>
                                                                    {lead.id}
                                                                </td>
                                                                <td>
                                                                    {lead.affinity}
                                                                    %</td>
                                                                <td>
                                                                    <select value={lead.tag || ""} onChange={(e) => handleTagChangeLocal(e, lead.id)} disabled={rol?.toLowerCase() === 'supervisor'}>
                                                                        <option value="Seguimiento">Seguimiento</option>
                                                                        <option value="Llamar más adelante">Llamar más adelante</option>
                                                                        <option value="No contesta">No contesta</option>
                                                                        <option value="Apartado">Apartado</option>
                                                                        <option value="No comprará">No comprará</option>
                                                                        <option value="">Sin Etiqueta</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <select value={lead.contracting_status || "Contacto"} onChange={(e) => handleContractingStatusChangeLocal(e, lead.id)} disabled={rol?.toLowerCase() === 'supervisor'}>
                                                                        <option value="Contacto">Contacto</option>
                                                                        <option value="Calificado">Calificado</option>
                                                                        <option value="Cita">Cita</option>
                                                                        <option value="Visita">Visita</option>
                                                                        <option value="Potencial">Potencial</option>
                                                                        <option value="Cierre">Cierre</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    {rol && ['asesor', 'supervisor'].includes(rol.toLowerCase()) ? (
                                                                        <div className="lead-date-format-v3-1">
                                                                            {getRecruiterName(lead.recruiter)}
                                                                        </div>
                                                                    ) : (
                                                                        <select
                                                                            value={lead.recruiter === null || lead.recruiter === undefined ? '' : lead.recruiter}
                                                                            onChange={(e) => handleRecruiterChange(e.target.value, lead.id)}
                                                                            style={(!lead.recruiter || lead.recruiter === null) ? { backgroundColor: '#f0f0f0', color: '#8E9DAA' } : {}}
                                                                        >
                                                                            <option value="">Sin asignar</option>
                                                                            {listaUsers?.sort((a, b) => a.first_name.localeCompare(b.first_name)).map((asesor) => (
                                                                                <option key={asesor.id} value={asesor.id}>
                                                                                    {asesor.first_name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    )}
                                                                </td>
                                                                <td className="acciones-v3">
                                                                    {lead.discard === false && <button className="btn-acciones-web" onClick={() => {
                                                                        openModalAccionesWeb()
                                                                        setIdLead(lead.id)
                                                                    }}>
                                                                        <img src={accion} alt="accion" className="imagen-estandar" />
                                                                        <img src={accionhover} alt="accionhover" className="imagen-oculta" />
                                                                    </button>}
                                                                    {lead.discard === true && <button className="btn-omitDiscard-web" onClick={() => {
                                                                        openModalOmitirDiscard()
                                                                        setIdLead(lead.id)
                                                                    }}>
                                                                        <img src={checkgreen} alt="accion" className="imagen-estandar" />
                                                                        <img src={checkWite} alt="accionhover" className="imagen-oculta" />
                                                                    </button>}
                                                                </td>
                                                                <td>
                                                                    <div className="tableV3-intento-candidate" style={{
                                                                        background: calcularColorFondoIntentos(lead.contact_attempts || 0).fondo,
                                                                        color: calcularColorFondoIntentos(lead.contact_attempts || 0).color,
                                                                    }}>
                                                                        {lead.contact_attempts || 0}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="tableV3-taskVenced-candidate" style={{
                                                                        background: calcularColorFondoTask(lead.open_tasks || 0),
                                                                    }}>
                                                                        {lead.open_tasks || 0}
                                                                    </div>
                                                                </td>
                                                                <td><div className="lead-date-format-v3-1">{formatearFecha(lead.created_date)}</div></td>
                                                                <td><div className="lead-date-format-v3-1">{formatearFecha(lead.postulation_date)}</div></td>
                                                                <td><div className={`lead-date-format-v3-1${!lead.visited_date ? ' sin-visita' : ''}`}>{formatearFechaVisita(lead.visited_date)}</div></td>
                                                            </>}
                                                        </div>
                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {tableB === false && <div className="cuadro-row9-2" style={{
                                gridColumn: gridColumn3 ? 'span 6' : 'span 9',
                                borderRadius: '0px 18px 18px 0px'
                            }}>
                                <div className="header-info-lead" style={{ borderRadius: '0px 18px 0px 0px' }}>
                                    <div>
                                        <section>
                                            <img src={personV3} alt="" />
                                        </section>
                                        <section>
                                            <label onClick={(e) => { e.stopPropagation(); }} style={{ maxWidth: gridColumn3 ? '250px' : '' }}>
                                                {dataLead?.candidate_name}
                                            </label>
                                            <span>{formatearFecha(dataLead?.review_date)}</span>
                                        </section>
                                    </div>
                                    <div>
                                        <div className="tooltip-container">
                                            <button onClick={() => handleOption('Informacion')}>{optionContac === 'Informacion' ? <img src={informacion} alt="" /> : <img src={informacionNA} alt="" />}</button>
                                            <div className="tooltip">Información del contacto</div>
                                        </div>
                                        <div className="tooltip-container">
                                            <button onClick={() => handleOption('Tareas')}>{optionContac === 'Tareas' ? <img src={tareas} alt="" /> : <img src={tareasNA} alt="" />}</button>
                                            <div className="tooltip">Tareas asignadas</div>
                                        </div>
                                        <div className="tooltip-container">
                                            <button onClick={() => handleOption('Intentos')}>{optionContac === 'Intentos' ? <img src={intentos} alt="" /> : <img src={intentosNA} alt="" />}</button>
                                            <div className="tooltip">Intentos de contacto</div>
                                        </div>
                                        <div className="tooltip-container">
                                            <button onClick={() => handleOption('Historial')}>{optionContac === 'Historial' ? <img src={historial} alt="" /> : <img src={historialNA} alt="" />}</button>
                                            <div className="tooltip">Historial completo</div>
                                        </div>
                                        <div className="tooltip-container">
                                            <button
                                            //    onClick={() => handleOption('WhatsApp')}
                                            >{optionContac === 'WhatsApp' ? <img src={whats} alt="" /> : <img src={whatsNA} alt="" />}</button>
                                            <div className="tooltip">WhatsApp (Próximamente)</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="body-row9-v3">
                                    {optionContac === 'Informacion' && <div style={{ display: "flex", height: "100%", overflowY: "auto" }}>
                                        <div className="body-lead-v3">
                                            <section>
                                                <label>Edad</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={agePATCH}
                                                    onChange={(e) => setValorSelect1(e.target.value)}>
                                                    <option value="No estoy seguro">No estoy seguro</option>
                                                    <option value="18 a 20">18 a 20</option>
                                                    <option value="21 a 25">21 a 25</option>
                                                    <option value="26 a 30">26 a 30</option>
                                                    <option value="31 a 35">31 a 35</option>
                                                    <option value="36 a 40">36 a 40</option>
                                                    <option value="41 a 45">41 a 45</option>
                                                    <option value="46 a 50">46 a 50</option>
                                                    <option value="51 a 55">51 a 55</option>
                                                    <option value="Mas de 60">Más de 60</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Estado civil</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={marital_statusPATCH}
                                                    onChange={(e) => setValorSelect2(e.target.value)}>
                                                    <option value="Sin respuesta">Sin respuesta</option>
                                                    <option value="Soltero">Soltero</option>
                                                    <option value="Casado">Casado</option>
                                                    <option value="Divorciado">Divorciado</option>
                                                    <option value="Viudo">Viudo</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Lugar de residencia</label>
                                                <input placeholder="Sin respuesta" type="text"
                                                    disabled={!enModoEdicion}
                                                    value={cityPATCH}
                                                    onChange={(e) => setValorInput1(e.target.value)} />
                                            </section>
                                            <section>
                                                <label>Etapa de vida</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={life_statusPATCH}
                                                    onChange={(e) => setValorSelect3(e.target.value)}>
                                                    <option value="Sin respuesta">Sin respuesta</option>
                                                    <option value="Joven soltero">Joven soltero (21-35)</option>
                                                    <option value="Adulto soltero (36+)">Adulto soltero (36+)</option>
                                                    <option value="Sin hijos">Sin hijos</option>
                                                    <option value="Familia pequeña (Hijos de 0-10)">Familia pequeña (Hijos de 0-10)</option>
                                                    <option value="Familia joven (Hijos de 11-20)">Familia joven (Hijos de 11-20)</option>
                                                    <option value="Familia grande (21+)">Familia grande (21+)</option>
                                                    <option value="Divorciado con hijos (21+)">Divorciado con hijos (21+)</option>
                                                    <option value="Adulto mayor (51+)">Adulto mayor (51+)</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Género</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={genderPATCH}
                                                    onChange={(e) => setValorSelect4(e.target.value)}>
                                                    <option value="Sin respuesta">Sin respuesta</option>
                                                    <option value="Hombre">Hombre</option>
                                                    <option value="Mujer">Mujer</option>
                                                    <option value="No Binario">No Binario</option>
                                                    <option value="No definido">No definido</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Razón de compra</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={purchase_reasonPATCH}
                                                    onChange={(e) => setValorSelect5(e.target.value)}>
                                                    <option value="Sin respuesta">Sin respuesta</option>
                                                    <option value="Vivir">Vivir</option>
                                                    <option value="Renta">Renta</option>
                                                    <option value="Inversion">Inversión</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Tiempo de compra</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={purchase_timePATCH}
                                                    onChange={(e) => setValorSelect6(e.target.value)}>
                                                    <option value="No estoy seguro">No estoy seguro</option>
                                                    <option value="Tres meses">Tres meses</option>
                                                    <option value="Seis meses">Seis meses</option>
                                                    <option value="Un año">Un año</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Presupuesto aproximado</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={budgetPATCH}
                                                    onChange={(e) => setValorSelect7(e.target.value)}>
                                                    <option value="Sin respuesta">Sin respuesta</option>
                                                    <option value="$400,000 a $490,000">$400,000 a $490,000</option>
                                                    <option value="$500,000 a $780,000">$500,000 a $780,000</option>
                                                    <option value="$790,000 a $890,000">$790,000 a $890,000</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Forma de pago</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={payment_typePATCH}
                                                    onChange={(e) => setValorSelect8(e.target.value)}>
                                                    <option value="Sin respuesta">Sin respuesta</option>
                                                    <option value="Contado Riguroso">Contado Riguroso</option>
                                                    <option value="Contado Plazo">Contado Plazo</option>
                                                    <option value="Crédito Infonavit">Crédito Infonavit</option>
                                                    <option value="Crédito Interno">Crédito Interno</option>
                                                    <option value="Crédito Bancario">Crédito Bancario</option>
                                                    <option value="Credito Hipotecario">Credito Hipotecario</option>
                                                    <option value="Fovissste">Fovissste</option>
                                                    <option value="Fovissste Aliados">Fovissste Aliados</option>
                                                    <option value="Fovissste Para Todos">Fovissste Para Todos</option>
                                                    <option value="Infonavit Total">Infonavit Total</option>
                                                    <option value="Apoyo Infonavit">Apoyo Infonavit</option>
                                                    <option value="Cofinavit">Cofinavit</option>
                                                    <option value="CFE">CFE</option>
                                                    <option value="Telmex">Telmex</option>
                                                    <option value="Cofinanciamiento">Cofinanciamiento</option>
                                                    <option value="Cajas de Ahorro">Cajas de Ahorro</option>
                                                    <option value="Otro">Otro</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Origen de prospecto</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={originPATCH}
                                                    onChange={(e) => setValorSelect9(e.target.value)}>
                                                    <optgroup label="Medios Digitales">
                                                        <option value="Base_Datos">Base de Datos</option>
                                                        <option value="Facebook">Facebook</option>
                                                        <option value="Facebook_Desktop_Feed">Facebook Ads</option>
                                                        <option value="Google">Google</option>
                                                        <option value="Instagram">Instagram</option>
                                                        <option value="Whatsapp">Whatsapp</option>
                                                        <option value="Tiktok">Tiktok</option>
                                                        <option value="Página web">Pagina web</option>
                                                        <option value="Redes sociales">Redes sociales</option>
                                                    </optgroup>
                                                    <optgroup label="Medios Tradicionales">
                                                        <option value="Broker">Broker o Asesor Externo</option>
                                                        <option value="Cambaceo">Cambaceo</option>
                                                        <option value="Contacto Directo">Contacto Directo</option>
                                                        <option value="Espectacular">Espectacular</option>
                                                        <option value="Inmobiliaria Externa">Inmobiliaria Externa</option>
                                                        <option value="Lonas">Lonas</option>
                                                        <option value="Periodico">Periodico</option>
                                                        <option value="Radio">Radio</option>
                                                        <option value="Recompra">Recompra</option>
                                                        <option value="Revista">Revista</option>
                                                        <option value="Referidos">Referidos</option>
                                                        <option value="Señaletica">Señaletica</option>
                                                        <option value="Telefono">Telefono</option>
                                                        <option value="Televisión">Televisión</option>
                                                        <option value="Volante">Volante</option>
                                                        <option value="Walk-in">Walk-in</option>
                                                    </optgroup>
                                                    <optgroup label="Portales Inmobiliarios">
                                                        <option value="Inmuebles 24">Inmuebles 24</option>
                                                        <option value="Lamudi">Lamudi</option>
                                                        <option value="Metros cúbicos">Metros cúbicos</option>
                                                        <option value="Propiedades.com">Propiedades.com</option>
                                                        <option value="Segundamano">Segundamano</option>
                                                        <option value="Tu Hogar México">Tu Hogar México</option>
                                                        <option value="Vivanuncios">Vivanuncios</option>
                                                    </optgroup>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Medio de contacto</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion}
                                                    value={contact_typePATCH}
                                                    onChange={(e) => setValorSelect10(e.target.value)}>
                                                    <option value="Teléfono">Teléfono</option>
                                                    <option value="Correo">Correo</option>
                                                    <option value="Whatsapp">Whatsapp</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Fecha de prospección</label>
                                                <input type="date"
                                                    disabled={!enModoEdicion}
                                                    value={postulation_date}
                                                    onChange={handleDateChange} />
                                            </section>
                                            <section>
                                                <label>Fecha de creación</label>
                                                <span>{formatDateToLongDate(dataLead ? dataLead.created_date : 'Cargando...')}</span>
                                            </section>
                                            <section>
                                                <label>Etiqueta</label>
                                                <select style={estiloSelect} disabled={!enModoEdicion || rol?.toLowerCase() === 'supervisor'}
                                                    value={tag}
                                                    onChange={(e) => setValorSelect11(e.target.value)}>
                                                    <option value="Sin etiqueta">Sin etiqueta</option>
                                                    <option value="Seguimiento">Seguimiento</option>
                                                    <option value="Llamar más adelante">Llamar más adelante</option>
                                                    <option value="No contesta">No contesta</option>
                                                    <option value="Apartado">Apartado</option>
                                                    <option value="No comprará">No comprará</option>
                                                </select>
                                            </section>
                                            <section>
                                                <label>Visitó desarrollo</label>
                                                {enModoEdicion ? (
                                                    <input type="date"
                                                        value={visited_date ? visited_date.split('T')[0] : ''}
                                                        onChange={handleVisitedDateChange}
                                                        max={`${new Date().getFullYear()}-${String(new Date().getMonth()+1).padStart(2,'0')}-${String(new Date().getDate()).padStart(2,'0')}`} />
                                                ) : (
                                                    <span style={{
                                                        display: 'block'
                                                    }}>
                                                        {visited_date ? (() => {
                                                            const date = visited_date.split('T')[0];
                                                            const [year, month, day] = date.split('-');
                                                            return `${day}/${month}/${year}`;
                                                        })() : 'No ha visitado desarrollo'}
                                                    </span>
                                                )}
                                            </section>
                                            {enModoEdicion ? (<>
                                                <button id="cancelV3" onClick={() => cancelarEdicion()} style={{ borderRadius: '50px' }}>Cancelar</button>
                                                <button onClick={() => {
                                                    const prevDate = dataLead?.visited_date ? String(dataLead.visited_date).split('T')[0] : null;
                                                    const newDate = visited_date ? String(visited_date).split('T')[0] : null;
                                                    handlePatchRequest();
                                                    if (newDate && newDate !== prevDate) {
                                                        postActionNote(
                                                            dataLead?.id,
                                                            'Fecha de visita',
                                                            `${nameMyUser} agendó una visita para el ${formatearFechaVisita(newDate)}`
                                                        );
                                                    }
                                                    // Actualizar la tabla después de editar
                                                    setTimeout(() => {
                                                        fetchAllLeadsFromBackend();
                                                        cancelarEdicion();
                                                    }, 1000);
                                                }} style={{ borderRadius: '50px' }}>Guardar</button></>) :
                                                (<button onClick={() => activarEdicion()}
                                                    style={{ borderRadius: '50%' }}
                                                // style={{ right: gridColumn3 ? '360px' : '60px' }}
                                                >
                                                    <img src={pencil} alt="editar" />
                                                </button>)}
                                        </div>
                                        <div className="infoBasic2-lead-v3">
                                            <div>
                                                <span id="letra">{primeraLetraLead}</span>
                                            </div>
                                            <input
                                                id="nameInfo"
                                                disabled={!edicion}
                                                value={candidate_name}
                                                onChange={(e) => setNameLead(e.target.value)}
                                                style={{ borderBottom: edicion ? '1px solid #a1a1a186' : '1px solid #fff' }}
                                            />
                                            <label>Correo electrónico</label>
                                            <input
                                                disabled={!edicion}
                                                value={email}
                                                onChange={(e) => setEmailLead(e.target.value)}
                                                style={{ borderBottom: edicion ? '1px solid #a1a1a186' : '1px solid #fff' }}
                                            />
                                            <label id="phone">Número de teléfono</label>
                                            <input
                                                disabled={!edicion}
                                                value={phone_number}
                                                onChange={(e) => setPhoneLead(e.target.value)}
                                                maxLength={10}
                                                style={{ borderBottom: edicion ? '1px solid #a1a1a186' : '1px solid #fff' }}
                                            />
                                            {rolActivo === 'Administrador' && (
                                                <button
                                                    className="btn-delete-lead"
                                                    onClick={handleDeleteLead}
                                                    title="Eliminar contacto"
                                                >
                                                    <img src={trashIcon} alt="eliminar" />
                                                    Eliminar contacto
                                                </button>
                                            )}
                                            <section className="porcentajes-infoBasic-v3">
                                                <div>
                                                    <span>{dataLead ? dataLead.affinity : 50}%</span>
                                                    <label>Afinidad</label>
                                                </div>
                                                <div>
                                                    <span>{dataLead ? dataLead.interest : 100}%</span>
                                                    <label>Interés</label>
                                                </div>
                                            </section>
                                            <section className="btns-infoBasic-v3">
                                                {edicion ? (<>
                                                    <button onClick={() => { handlePatch2Request(); setTimeout(() => { cancelarEdicionInfo() }, 500) }}>Guardar</button>
                                                    <button onClick={() => cancelarEdicionInfo()}>Cancelar</button>
                                                </>) :
                                                    (<>
                                                        <button onClick={() => activarEdicionInfo()}>Editar</button>
                                                        <button onClick={() => openModal4()}>Descartar</button>
                                                    </>)}
                                            </section>
                                        </div>
                                    </div>
                                    }
                                    {optionContac === 'Tareas' && <div className="body-tasks-v3">
                                        <section className="content-tasks-v3">
                                            {tasksStatus === 'Total' && <>
                                                {tasksByLead && Array.isArray(tasksByLead) && tasksByLead.length > 0 ? (
                                                    tasksByLead
                                                        .sort((a, b) => new Date(b.expiration) - new Date(a.expiration))
                                                        .map(task => {
                                                            setNumeroUser(task.responsable)
                                                            return (
                                                                <section key={task.id} className="task-v3">
                                                                    <label>{task.title}</label>
                                                                    <div>
                                                                        <span>{task.expiration}</span>
                                                                        <span>{nameUser}</span>
                                                                    </div>
                                                                </section>
                                                            )
                                                        })) : (<div className="no-tasks-v3">
                                                            <div>
                                                                <h4>Sin tareas creadas</h4>
                                                                <p>Comienza creando una tarea</p>
                                                            </div>
                                                            <img src={image2} alt="vacants" />
                                                        </div>)}
                                            </>}
                                            {tasksStatus === 'Abiertas' && <>
                                                {tasksByLeadOpen && Array.isArray(tasksByLeadOpen) && tasksByLeadOpen.length > 0 ? (
                                                    tasksByLeadOpen
                                                        .sort((a, b) => new Date(b.expiration) - new Date(a.expiration))
                                                        .map(task => {
                                                            setNumeroUser(task.responsable)
                                                            return (
                                                                <section key={task.id} className="task-v3">
                                                                    <label>{task.title}</label>
                                                                    <div>
                                                                        <span>{task.expiration}</span>
                                                                        <span>{nameUser}</span>
                                                                    </div>
                                                                </section>
                                                            )
                                                        })) : (<div className="no-tasks-v3">
                                                            <div>
                                                                <h4>Sin tareas creadas</h4>
                                                                <p>Comienza creando una tarea</p>
                                                            </div>
                                                            <img src={image2} alt="vacants" />
                                                        </div>)}
                                            </>}
                                            {tasksStatus === 'Finalizadas' && <>
                                                {tasksByLeadFinish && Array.isArray(tasksByLeadFinish) && tasksByLeadFinish.length > 0 ? (
                                                    tasksByLeadFinish
                                                        .sort((a, b) => new Date(b.expiration) - new Date(a.expiration))
                                                        .map(task => {
                                                            setNumeroUser(task.responsable)
                                                            return (
                                                                <section className="task-v3">
                                                                    <label>{task.title}</label>
                                                                    <div>
                                                                        <span>{task.expiration}</span>
                                                                        <span>{nameUser}</span>
                                                                    </div>
                                                                </section>
                                                            )
                                                        })) : (<div className="no-tasks-v3">
                                                            <div>
                                                                <h4>Sin tareas creadas</h4>
                                                                <p>Comienza creando una tarea</p>
                                                            </div>
                                                            <img src={image2} alt="vacants" />
                                                        </div>)}
                                            </>}
                                        </section>
                                        <section className="naveg-tasks-v3">
                                            <div>
                                                <div
                                                    onClick={() => handleTasks('Total')}
                                                    style={{ border: tasksStatus === 'Total' ? '1px solid #FF4B78' : '#a1a1a186 1px solid' }}
                                                >Total</div>
                                                <div
                                                    onClick={() => handleTasks('Abiertas')}
                                                    style={{ border: tasksStatus === 'Abiertas' ? '1px solid #FF4B78' : '#a1a1a186 1px solid' }}
                                                >Pendientes</div>
                                                <div
                                                    onClick={() => handleTasks('Finalizadas')}
                                                    style={{ border: tasksStatus === 'Finalizadas' ? '1px solid #FF4B78' : '#a1a1a186 1px solid' }}
                                                >Finalizadas</div>
                                            </div>
                                            <button onClick={() => openModalTaskByLead()} style={{
                                                padding: gridColumn3 ? '5px 7px' : '5px 10px',
                                                marginRight: gridColumn3 ? '10px' : '40px'
                                            }}><img src={iconSvg} alt="" />Añadir tarea</button>
                                        </section>
                                    </div>}
                                    {optionContac === 'Intentos' && <div className="intentos-v3">
                                        <div className="contenedor-intentos-v3">
                                            {(() => {
                                                // Filtrar intentos del historial completo
                                                const intentos = historialCompleto && Array.isArray(historialCompleto)
                                                    ? historialCompleto.filter(note => note.type_note === 'intento')
                                                    : [];


                                                if (intentos.length > 0) {
                                                    return intentos.map(intento => (
                                                        <section key={intento.id} className="intento-v3">
                                                            <label id="date-created">{dateFormatIntento(intento.created)}</label>
                                                            <div className="timeLine-v3">
                                                                <span id="check"><img src={check} alt="" /></span>
                                                                <div className="line-v3"></div>
                                                            </div>
                                                            <div className="info-intento-v3">
                                                                <label>{intento.user === Id ? (nameMyUser || 'Usuario actual') : (nameUser || 'Usuario')}</label>
                                                                <span>{intento.title}</span>
                                                                <p>{intento.observation}</p>
                                                            </div>
                                                        </section>
                                                    ));
                                                } else {
                                                    return (
                                                        <div className="sin-intentos-v3">
                                                            Hasta el momento, no se ha registrado ningún intento de contacto.
                                                        </div>
                                                    );
                                                }
                                            })()}
                                            <div ref={scrollRef}></div>
                                        </div>
                                        <div className="creacion-notas-v3" style={{ borderRadius: gridColumn3 ? '0px' : '0px 0px 18px 0px' }}>
                                            <section>
                                                <input
                                                    placeholder="Titulo..."
                                                    value={newTitle}
                                                    onChange={(e) => setNewTitle(e.target.value)}
                                                />
                                                <textarea
                                                    rows="1"
                                                    cols="12"
                                                    placeholder="Descripcion de nota o alerta..."
                                                    value={newObservation}
                                                    onChange={(e) => setNewObservation(e.target.value)}
                                                ></textarea>
                                            </section>
                                            <button onClick={() => {
                                                handleNotesCreate()
                                                setAllLeadsFromBackend(prev => prev.map(l =>
                                                    l.id === dataLead?.id ? { ...l, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                                ));
                                                setLeads(prev => (prev || []).map(l =>
                                                    l.id === dataLead?.id ? { ...l, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                                ));
                                                touchReviewDate(dataLead?.id)
                                                resetInputs()
                                            }}><img src={send} alt="" /></button>
                                        </div>
                                    </div>}
                                    {optionContac === 'Historial' && <div className="historial-v3" style={{ borderRadius: gridColumn3 ? '0px' : '0px 0px 18px 0px' }}>
                                        <div className="contenedor-historial-v3">
                                            {historialCompleto && Array.isArray(historialCompleto) && historialCompleto?.sort((a, b) => new Date(b.created) - new Date(a.created))
                                                .map((notes) => (
                                                    <section key={notes.id} className="accion-v3">
                                                        <label id="date-created">{dateFormatIntento(notes.created)}</label>
                                                        <div className="timeLine-v3">
                                                            <span id="check"><img src={check} alt="" /></span>
                                                            <div className="line-v3"></div>
                                                        </div>
                                                        <div className="info-intento-v3">
                                                            <label>{notes.user === Id ? (nameMyUser || 'Usuario actual') : (nameUser || 'Usuario')}</label>
                                                            <span>{notes.title}</span>
                                                            <p>{notes.observation}</p>
                                                        </div>
                                                    </section>
                                                ))}
                                        </div>
                                    </div>}
                                    {optionContac === 'WhatsApp' && <div className="whatsapp-v3" style={{ borderRadius: gridColumn3 ? '0px' : '0px 0px 18px 0px' }}>
                                        <div className="conversacion-whats-v3">
                                            <div className="chat-container">
                                                <div className="message">
                                                    <div className="profile-image-right">
                                                        <img src={whatsNA} alt="Imagen de perfil" />
                                                    </div>
                                                    <div className="bubble-message left-message" style={{ maxWidth: gridColumn3 ? '70%' : '80%' }}>
                                                        <p>Hola, soy Juan. ¿Podemos confirmar la cita para visitar el desarrollo habitacional este sábado?</p>
                                                        <span>11:59 a. m.</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="chat-container-response">
                                                <div className="response">
                                                    <div className="bubble-message right-message background-whatsapp" style={{ maxWidth: gridColumn3 ? '412px' : '727px' }}>
                                                        <p>¡Hola Juan! Claro, la cita está confirmada para el sábado a las 10 a.m. ¿Algún detalle que debamos tener en cuenta?</p>
                                                        <div className="status-whats-v3">
                                                            <span>11:59 a. m.</span>
                                                            <img src={visto} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="chat-container">
                                                <div className="message">
                                                    <div className="profile-image-right">
                                                        <img src={whatsNA} alt="Imagen de perfil" />
                                                    </div>
                                                    <div className="bubble-message left-message" style={{ maxWidth: gridColumn3 ? '70%' : '80%' }}>
                                                        <p>Perfecto, gracias. ¿La dirección exacta?</p>
                                                        <span>12:00 p. m.</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="chat-container-response">
                                                <div className="response">
                                                    <div className="bubble-message right-message background-whatsapp" style={{ maxWidth: gridColumn3 ? '412px' : '727px' }}>
                                                        <p> La dirección es Calle Desarrollo, 123. Te esperamos. ¿Algo más en lo que pueda ayudarte?</p>
                                                        <div className="status-whats-v3">
                                                            <span>12:00 p. m.</span>
                                                            <img src={recibido} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="chat-container">
                                                <div className="message">
                                                    <div className="profile-image-right">
                                                        <img src={whatsNA} alt="Imagen de perfil" />
                                                    </div>
                                                    <div className="bubble-message left-message" style={{ maxWidth: gridColumn3 ? '70%' : '80%' }}>
                                                        <p>No, eso es todo. ¡Gracias!</p>
                                                        <span>12:01 p. m.</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="chat-container-response">
                                                <div className="response">
                                                    <div className="bubble-message right-message background-whatsapp" style={{ maxWidth: gridColumn3 ? '412px' : '727px' }}>
                                                        <p>De nada, Juan. ¡Nos vemos el sábado!</p>
                                                        <div className="status-whats-v3">
                                                            <span>12:01 p. m.</span>
                                                            <img src={enviado} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div ref={scrollRef}></div>
                                        </div>
                                        <div className="escrbir-mensaje" style={{ borderRadius: gridColumn3 ? '0px' : '0px 0px 18px 0px' }}>
                                            <button><img src={carita} alt="" /></button>
                                            <button><img src={clip} alt="" /></button>
                                            <input type="text" placeholder="Escribe un mensaje" />
                                            <button><img src={send} alt="" /></button>
                                        </div>
                                    </div>}
                                </div>
                            </div>}
                            {gridColumn3 && <div className="cuadro-row3-3" >
                                {/* <div className="headerWa-infoLead-v3">
                                <img onClick={() => { closeInfoLead() }} src={close} alt="" />
                                <label>Info. del contacto</label>
                            </div> */}
                            </div>}
                        </div>
                        <div className="paginacion-v3">
                            <div className="paginacion-left">
                                <span
                                    className={`paginacion-text ${page > 1 ? 'active' : 'disabled'}`}
                                    onClick={() => page > 1 && handlePageChange(1)}
                                >
                                    Inicio
                                </span>
                                <div
                                    className={`paginacion-back ${page > 1 ? 'active' : 'disabled'}`}
                                    onClick={() => page > 1 && handlePageChange(page - 1)}
                                >
                                    <img src={chevronBackGrey} alt="back" />
                                </div>
                            </div>
                            <div className="paginacion-center">
                                {generatePageNumbers().map((pageNum, index) => (
                                    <div
                                        key={index}
                                        className={`paginacion-center-number ${pageNum === page ? 'active' : ''} ${pageNum === '...' ? 'ellipsis' : ''}`}
                                        onClick={() => pageNum !== '...' && handlePageChange(pageNum)}
                                    >
                                        {pageNum}
                                    </div>
                                ))}
                            </div>
                            <div className="paginacion-right">
                                <div
                                    className={`paginacion-forward ${page < Math.ceil(totalLeads / itemsPerPage) ? 'active' : 'disabled'}`}
                                    onClick={() => page < Math.ceil(totalLeads / itemsPerPage) && handlePageChange(page + 1)}
                                >
                                    <img src={chevronForwardGrey} alt="forward" />
                                </div>
                                <span
                                    className={`paginacion-text ${page < Math.ceil(totalLeads / itemsPerPage) ? 'active' : 'disabled'}`}
                                    onClick={() => page < Math.ceil(totalLeads / itemsPerPage) && handlePageChange(Math.ceil(totalLeads / itemsPerPage))}
                                >
                                    Fin
                                </span>
                            </div>
                        </div>
                    </div>
                </div>) : (<div className="main-content">
                    <div className="leads-vacants">
                        <div className="leads-vacants-info">
                            <p>Sin contactos disponibles</p>
                            <span>Si no cuentas con contactos aún, puedes agregarlos dando clic aquí.</span>
                            <div className="leads-vacants-buttons">
                                <button id="add" onClick={openModal}><img src={iconSvg} alt="" /> Agregar contactos</button>
                                <span>ó</span>
                                <button id="transfer" onClick={() => { navigate('/Subir-contactos') }}><img src={transfer} alt="" />Transfiere tu .csv</button>
                            </div>
                        </div>
                        <img src={imgMovil} alt="" />
                    </div>
                </div>)}
                <div className="contactos-movil">
                    <div className="container-main-movil">
                        <div className="carrousel-container-cards-movil">
                            <div className="card-carrousel-movil">
                                <button className={`custom-button ${activeButton === 1 ? 'active' : ''}`}
                                    onClick={() => handleButtonClickIndicadores(1)}>{totalLength}</button>
                                <label>CONTACTOS</label>
                            </div>
                            <div className="card-carrousel-movil">
                                <button className={`custom-button ${activeButton === 2 ? 'active' : ''}`}
                                    onClick={() => handleButtonClickIndicadores(2)}>{calificadoLength}</button>
                                <label>CALIFICADOS</label>
                            </div>
                            <div className="card-carrousel-movil">
                                <button className={`custom-button ${activeButton === 3 ? 'active' : ''}`}
                                    onClick={() => handleButtonClickIndicadores(3)}>{citaLength}</button>
                                <label>CITAS</label>
                            </div>
                            <div className="card-carrousel-movil">
                                <button className={`custom-button ${activeButton === 4 ? 'active' : ''}`}
                                    onClick={() => handleButtonClickIndicadores(4)}>{visitaLength}</button>
                                <label>VISITAS</label>
                            </div>
                            <div className="card-carrousel-movil">
                                <button className={`custom-button ${activeButton === 5 ? 'active' : ''}`}
                                    onClick={() => handleButtonClickIndicadores(5)}>{potencialLength}</button>
                                <label>POTENCIALES</label>
                            </div>
                            <div className="card-carrousel-movil">
                                <button className={`custom-button ${activeButton === 6 ? 'active' : ''}`}
                                    onClick={() => handleButtonClickIndicadores(6)}>{cierreLength}</button>
                                <label>CIERRES</label>
                            </div>
                        </div>
                        {rol === 'Asesor' && <div>
                            <div className="searchbar-buttons-movil">
                                <input
                                    type="text"
                                    placeholder="Buscar..."
                                    value={localSearchTerm}
                                    onChange={handleSearch}
                                />
                                <button className="btn-search-movil">Buscar</button>
                                <button className="btn-clear-movil" onClick={clearSearch}><img src={iconSvg2} alt="X" /></button>
                                <button onClick={openModalFilter} className="btn-filter-movil"><img src={filterMovil} alt="Y" /></button>
                            </div>
                        </div>}
                        {(rol === 'Coordinador' || rol === 'Supervisor') && <div>
                            <div className="searchbar-buttons-movil">
                                <input
                                    type="text"
                                    placeholder="Buscar..."
                                    value={localSearchTerm}
                                    onChange={handleSearch}
                                />
                                <button className="btn-search-movil">Buscar</button>
                                <button className="btn-clear-movil" onClick={clearSearch}><img src={iconSvg2} alt="X" /></button>
                                <button onClick={openModalFilter} className="btn-filter-movil"><img src={filterMovil} alt="Y" /></button>
                                <button onClick={openModalDownLeadMovil} className="btn-dnwld-movil"><img src={downloadMovil} alt="downloadMovil" /></button>
                            </div>
                        </div>}
                        {filteredContacts && Array.isArray(filteredContacts) &&
                            getFilteredContacts()
                                .slice(startIndex, endIndex)
                                .map((item, index) => {
                                    return (<div key={index} className="lead-card-movil">
                                        <div className="container-data-lead-movil">
                                            <div className="emoji-lead-movil">
                                                <span>
                                                    {isDormido(calculateDateDifference(item.review_date), item.contracting_status)
                                                        ? <span style={{ fontSize: '22px', lineHeight: 1 }}>😴</span>
                                                        : <img src={getEmojiImage(calculateDateDifference(item.review_date))} alt="" />
                                                    }
                                                </span>
                                            </div>
                                            <div className="data-lead-movil">
                                                <NavLink onClick={() => setIdLead(item.id)} to={'/Perfil-de-contacto'} className="nav-links-movil">
                                                    <label className="name-lead-movil">{item.candidate_name}</label>
                                                </NavLink>
                                                <label className="type-lead-movil">{item.contracting_status || "Contacto"} </label>
                                                <label className="date-lead-movil" style={{
                                                    color: calcularColorFondo(item.review_date, item.contracting_status),
                                                }}>{formatearFecha(item.review_date)}</label>
                                            </div>
                                        </div>
                                        <div className="container-buttons-lead-movil">
                                            <div onClick={() => {
                                                toggleDiv(index)
                                                setIdLead(item.id)
                                            }} className="lead-detalles-movil">
                                                Detalles
                                            </div>
                                            <div onClick={() => {
                                                openModalAcciones()
                                            }} className="lead-acciones-movil">
                                                Acciones
                                            </div>
                                            {mostrarDivArray && mostrarDivArray[index]
                                                && <div className="lead-detail-movil">
                                                    <div className="lead-detail-data-movil">
                                                        <label>Correo</label>
                                                        <label>{dataLead ? dataLead.email : ''}</label>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Telefono</label>
                                                        <label>{dataLead ? dataLead.phone_number : ''}</label>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Afinidad</label>
                                                        <label>{dataLead ? dataLead.affinity : '0'}%</label>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Origen</label>
                                                        <label>{dataLead ? getOriginLabel(dataLead.origin) : ''}</label>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Etiquetas</label>
                                                        <select value={dataLead ? dataLead.tag : ""}>
                                                            <option value="Seguimiento">Seguimiento</option>
                                                            <option value="Llamar más adelante">Llamar más adelante</option>
                                                            <option value="No contesta">No contesta</option>
                                                            <option value="Apartado">Apartado</option>
                                                            <option value="No comprará">No comprará</option>
                                                            <option value="">Sin Etiqueta</option>
                                                        </select>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Estatus</label>
                                                        <select value={dataLead ? dataLead.contracting_status : "Contacto"}>
                                                            <option value="Contacto">Contacto</option>
                                                            <option value="Calificado">Calificado</option>
                                                            <option value="Cita">Cita</option>
                                                            <option value="Visita">Visita</option>
                                                            <option value="Potencial">Potencial</option>
                                                            <option value="Cierre">Cierre</option>
                                                        </select>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Responsable</label>
                                                        <label>Rodrigo</label>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Intentos de contacto</label>
                                                        <label className="circle-intetodata-movil" style={{
                                                            background: calcularColorFondoIntentos(item.contact_attempts || 0).fondo,
                                                            color: `${calcularColorFondoIntentos(item.contact_attempts || 0).color} !important`,
                                                        }}>{item.contact_attempts || 0}</label>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Tareas vencidas</label>
                                                        <label className="circle-data-movil" style={{
                                                            background: calcularColorFondoTask(item.open_tasks || 0),
                                                        }}>{item.open_tasks || 0}</label>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Próximo contacto</label>
                                                        <label>{formatearFecha(item.postulation_date)}</label>
                                                    </div>
                                                    <div className="lead-detail-data-movil">
                                                        <label>Ultimo contacto</label>
                                                        <label>{formatearFecha(item.review_date)}</label>
                                                    </div>
                                                </div>}
                                        </div>
                                    </div>)
                                })}
                    </div>
                </div>
                <FabButton onClick={openModalAddMovil} />
                {isModalOpen && <div className="agregar-panel-overlay" onClick={closeModal} />}
                <div className={`agregar-panel${isModalOpen ? ' agregar-panel--open' : ''}`}>
                    <div className="agregar-panel-header">
                        <label>Agregar Contacto</label>
                        <button className="acciones-panel-close" onClick={closeModal}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    <div className="agregar-panel-body">
                    <div className="container-main-modal">
                        <div className="container-lead-modal">
                            <div className="name-container-lead-modal">
                                <div className="label-lead-modal">
                                    <label>Nombre</label>
                                </div>
                                <div className="input-lead-modal">
                                    <input
                                        placeholder="Escribe el nombre del contacto"
                                        value={modalCandidateName}
                                        onChange={handleNombreChange}
                                    />
                                    {candidate_nameError && <span className="error-message">{candidate_nameError}</span>}
                                </div>
                            </div>
                            <div className="date-container-lead-modal">
                                <div className="label-lead-modal">
                                    <label>Fecha de registro</label>
                                </div>
                                <div className="input-date-lead-modal">
                                    <input type="date" value={currentDate} readOnly />
                                </div>
                            </div>
                            <div className="label-lead-modal">
                                <label>Correo</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <input
                                    placeholder="Escribe el email del contacto"
                                    value={modalEmail}
                                    onChange={handleCorreoChange}
                                />
                                {emailError && <span className="error-message">{emailError}</span>}
                            </div>
                            <div className="label-lead-modal">
                                <label>Teléfono</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <input
                                    placeholder="Escribe el teléfono del contacto"
                                    value={modalPhoneNumber}
                                    onChange={handleTelefonoChange}
                                    maxLength={10}
                                />
                                {phone_numberError && <span className="error-message">{phone_numberError}</span>}
                            </div>
                            <div className="label-lead-modal">
                                <label>Edad</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalAge} onChange={handleEdadChange}>
                                    <option value="No estoy seguro">No estoy seguro</option>
                                    <option value="18 a 20">18 a 20</option>
                                    <option value="21 a 25">21 a 25</option>
                                    <option value="26 a 30">26 a 30</option>
                                    <option value="31 a 35">31 a 35</option>
                                    <option value="36 a 40">36 a 40</option>
                                    <option value="41 a 45">41 a 45</option>
                                    <option value="46 a 50">46 a 50</option>
                                    <option value="51 a 55">51 a 55</option>
                                    <option value="Más de 60">Más de 60</option>
                                </select>
                                {ageError && <span className="error-message">{ageError}</span>}
                            </div>
                            <div className="label-lead-modal">
                                <label>Estado civil</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalMaritalStatus} onChange={handleCivilChange}>
                                    <option value=""></option>
                                    <option value="Soltero">Soltero</option>
                                    <option value="Casado">Casado</option>
                                    <option value="Divorciado">Divorciado</option>
                                    <option value="Viudo">Viudo</option>
                                </select>
                            </div>
                            <div className="label-lead-modal">
                                <label>Lugar de residencia</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <input
                                    name="ciudad"
                                    value={modalCity}
                                    onChange={handleCiudadChange}
                                />
                                {cityError && <span className="error-message">{cityError}</span>}
                            </div>
                            <div className="label-lead-modal">
                                <label>Etapa de vida</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalLifeStatus} onChange={handleLifeChange}>
                                    <option value="null"></option>
                                    <option value="Joven soltero (21-35)">Joven soltero (21-35)</option>
                                    <option value="Adulto soltero (36+">Adulto soltero (36+)</option>
                                    <option value="Sin hijos">Sin hijos</option>
                                    <option value="Familia pequeña (Hijos de 0-10)">Familia pequeña (Hijos de 0-10)</option>
                                    <option value="Familia joven (Hijos de 11-20)">Familia joven (Hijos de 11-20)</option>
                                    <option value="Familia grande (21+)">Familia grande (21+)</option>
                                    <option value="Divorciado con hijos (21+)">Divorciado con hijos (21+)</option>
                                    <option value="Adulto mayor (51+)">Adulto mayor (51+)</option>
                                </select>
                            </div>
                            <div className="label-lead-modal">
                                <label>Género</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalGender} onChange={handleGeneroChange}>
                                    <option value=""></option>
                                    <option value="Hombre">Hombre</option>
                                    <option value="Mujer">Mujer</option>
                                    <option value="No Binario">No Binario</option>
                                    <option value="No definido">No definido</option>
                                </select>
                                {genderError && <span className="error-message">{genderError}</span>}
                            </div>
                            <div className="label-lead-modal">
                                <label>Rázon de compra</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalPurchaseReason} onChange={handleReasonChange}>
                                    <option value=""></option>
                                    <option value="Vivir">Vivir</option>
                                    <option value="Renta">Renta</option>
                                    <option value="Inversión">Inversión</option>
                                </select>
                            </div>
                            <div className="label-lead-modal">
                                <label>Tiempo de compra</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalPurchaseTime} onChange={handleCompraChange}>
                                    <option value="No estoy seguro">No estoy seguro</option>
                                    <option value="Tres meses">Tres meses</option>
                                    <option value="Seis meses">Seis meses</option>
                                    <option value="Un año">Un año</option>
                                </select>
                            </div>
                            <div className="label-lead-modal">
                                <label>Presupuesto aproximado</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalBudget} onChange={handlePresupuestoChange}>
                                    <option value="Sin respuesta">Sin respuesta</option>
                                    <option value="$400,000 a $490,000">$400,000 a $490,000</option>
                                    <option value="$500,000 a $780,000">$500,000 a $780,000</option>
                                    <option value="$790,000 a $890,000">$790,000 a $890,000</option>
                                </select>
                            </div>
                            <div className="label-lead-modal">
                                <label>Forma de pago</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalPaymentType} onChange={handleTipoPagoChange}>
                                    <option value="null"></option>
                                    <option value="Contado Riguroso">Contado Riguroso</option>
                                    <option value="Contado Plazo">Contado Plazo</option>
                                    <option value="Crédito Infonavit">Crédito Infonavit</option>
                                    <option value="Crédito Bancario">Crédito Bancario</option>
                                    <option value="Fovissste">Fovissste</option>
                                    <option value="Fovissste Aliados">Fovissste Aliados</option>
                                    <option value="Fovissste Para Todos">Fovissste Para Todos</option>
                                    <option value="Infonavit Total">Infonavit Total</option>
                                    <option value="Apoyo Infonavit">Apoyo Infonavit</option>
                                    <option value="Cofinavit">Cofinavit</option>
                                    <option value="CFE">CFE</option>
                                    <option value="Telmex">Telmex</option>
                                    <option value="Cofinanciamiento">Cofinanciamiento</option>
                                    <option value="Crédito Interno">Crédito Interno</option>
                                    <option value="Cajas de Ahorro">Cajas de Ahorro</option>
                                    <option value="Otro">Otro</option>
                                </select>
                            </div>
                            <div className="label-lead-modal">
                                <label>Medio de contacto</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalContactType} onChange={handleTipoChange}>
                                    <option value=""></option>
                                    <option value="Teléfono">Teléfono</option>
                                    <option value="Correo">Correo</option>
                                    <option value="Whatsapp">Whatsapp</option>
                                </select>
                                {contact_typeError && <span className="error-message">{contact_typeError}</span>}
                            </div>
                            <div className="label-lead-modal">
                                <label>Origen del contacto</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalOrigin} onChange={handleOrigenChange}>
                                    <option value=""></option>
                                    <optgroup label="Medios Digitales">
                                        <option value="Base_Datos">Base de Datos</option>
                                        <option value="Facebook">Facebook</option>
                                        <option value="Facebook_Desktop_Feed">Facebook Ads</option>
                                        <option value="Google">Google</option>
                                        <option value="Instagram">Instagram</option>
                                        <option value="Whatsapp">Whatsapp</option>
                                        <option value="Tiktok">Tiktok</option>
                                        <option value="Página web">Pagina web</option>
                                        <option value="Redes sociales">Redes sociales</option>
                                    </optgroup>
                                    <optgroup label="Medios Tradicionales">
                                        <option value="Broker">Broker o Asesor Externo</option>
                                        <option value="Cambaceo">Cambaceo</option>
                                        <option value="Contacto Directo">Contacto Directo</option>
                                        <option value="Espectacular">Espectacular</option>
                                        <option value="Inmobiliaria Externa">Inmobiliaria Externa</option>
                                        <option value="Lonas">Lonas</option>
                                        <option value="Periodico">Periodico</option>
                                        <option value="Radio">Radio</option>
                                        <option value="Recompra">Recompra</option>
                                        <option value="Revista">Revista</option>
                                        <option value="Referidos">Referidos</option>
                                        <option value="Señaletica">Señaletica</option>
                                        <option value="Telefono">Telefono</option>
                                        <option value="Televisión">Televisión</option>
                                        <option value="Volante">Volante</option>
                                        <option value="Walk-in">Walk-in</option>
                                    </optgroup>
                                    <optgroup label="Portales Inmobiliarios">
                                        <option value="Inmuebles 24">Inmuebles 24</option>
                                        <option value="Lamudi">Lamudi</option>
                                        <option value="Metros cúbicos">Metros cúbicos</option>
                                        <option value="Propiedades.com">Propiedades.com</option>
                                        <option value="Segundamano">Segundamano</option>
                                        <option value="Tu Hogar México">Tu Hogar México</option>
                                        <option value="Vivanuncios">Vivanuncios</option>
                                    </optgroup>
                                </select>
                                {originError && <span className="error-message">{originError}</span>}
                            </div>
                            <div className="label-lead-modal">
                                <label>Estatus</label>
                            </div>
                            <div className="input-date-lead-modal">
                                <select value={modalContractingStatus} onChange={handleEstatusChange} disabled={rol?.toLowerCase() === 'supervisor'}>
                                    <option value=""></option>
                                    <option value="Contacto">Contacto</option>
                                    <option value="Calificado">Calificado</option>
                                    <option value="Cita">Cita</option>
                                    <option value="Visita">Visita</option>
                                    <option value="Potencial">Potencial</option>
                                    <option value="Cierre">Cierre</option>
                                </select>
                                {contracting_statusError && <span className="error-message">{contracting_statusError}</span>}
                            </div>
                        </div>
                        {contextApiErrorMessage && (
                            <div style={{
                                padding: '10px',
                                margin: '10px 20px',
                                backgroundColor: '#ffebee',
                                border: '1px solid #f44336',
                                borderRadius: '4px',
                                color: '#d32f2f',
                                fontSize: '14px',
                                textAlign: 'center'
                            }}>
                                ❌ {contextApiErrorMessage}
                            </div>
                        )}
                        <div className="buttons-container-modal">
                            <button className="btn-cancel-modal" onClick={closeModal} type="reset">Cancelar</button>
                            <button className="btn-acept-modal" onClick={() => {
                                if (!modalCandidateName) {
                                    setCandidateNameError('Este campo es obligatorio');
                                } else {
                                    setCandidateNameError('');
                                }

                                // Email and phone are optional if at least one is provided
                                if (!modalEmail && !modalPhoneNumber) {
                                    setEmailError('Debes proporcionar al menos un correo o teléfono');
                                    setPhoneNumberError('Debes proporcionar al menos un correo o teléfono');
                                } else {
                                    setEmailError('');
                                    setPhoneNumberError('');
                                }

                                if (!modalGender) {
                                    setGenderError('Este campo es obligatorio');
                                } else {
                                    setGenderError('');
                                }

                                if (!modalContactType) {
                                    setContactTypeError('Este campo es obligatorio');
                                } else {
                                    setContactTypeError('');
                                }

                                if (!modalOrigin) {
                                    setOriginError('Este campo es obligatorio');
                                } else {
                                    setOriginError('');
                                }

                                if (modalCandidateName && (modalEmail || modalPhoneNumber) && modalGender && modalContactType && modalOrigin) {
                                    const leadData = {
                                        candidate_name: modalCandidateName,
                                        email: modalEmail,
                                        phone_number: modalPhoneNumber,
                                        age: modalAge,
                                        marital_status: modalMaritalStatus,
                                        city: modalCity,
                                        life_status: modalLifeStatus,
                                        gender: modalGender,
                                        purchase_reason: modalPurchaseReason,
                                        purchase_time: modalPurchaseTime,
                                        budget: modalBudget,
                                        payment_type: modalPaymentType,
                                        contact_type: modalContactType,
                                        origin: modalOrigin,
                                        contracting_status: modalContractingStatus,
                                        interest,
                                        initial_comment,
                                        vacant_code
                                    };

                                    // Lógica de asignación automática de recruiter según el rol
                                    if (rol && rol.toLowerCase() === 'asesor') {
                                        leadData.recruiter = Id;
                                    } else if (rol && (rol.toLowerCase() === 'coordinador' || rol.toLowerCase() === 'administrador' || rol.toLowerCase() === 'supervisor')) {
                                        leadData.recruiter = null; // Sin asignar
                                    }

                                    setUpLead(leadData);
                                    setBtnCreateLead(true);
                                }
                            }}>Aceptar</button>
                        </div>
                    </div>
                    </div>
                </div>
                <Modal isOpen={isModalOpenDownLeadWeb} onClose={closeModalDownLeadWeb}>
                    <div className="modal-title">
                        <label>Descargar contactos</label>
                    </div>
                    <div className="container-download-main-modal">
                        <div className="container-download-lead-modal">
                            <span>Selecciona los contactos que deseas descargar:</span>
                            <div className="options-download-lead-modal">
                                <input type="radio" name="download" value='1' />
                                <span> Contactos filtrados</span>
                            </div>
                            <div className="options-download-lead-modal">
                                <input type="radio" name="download" value='2' />
                                <span> Todos los contactos</span>
                            </div>
                        </div>
                    </div>
                    <div className="container-buttons-download-lead-movil">
                        <button className="btn-cancel-modal" onClick={closeModalDownLeadWeb} type="reset">Cancelar</button>
                        <button className="btn-acept-modal">Aceptar</button>
                    </div>
                </Modal>
                {isModalOpenAccionesWeb && <div className="acciones-panel-overlay" onClick={closeModalAccionesWeb} />}
                <div className={`acciones-panel${isModalOpenAccionesWeb ? ' acciones-panel--open' : ''}`}>
                    <div className="acciones-panel-header">
                        <div className="acciones-panel-lead-info">
                            <div className="acciones-panel-origin-icon">
                                <img src={getOriginImage(dataLead?.origin)} alt={dataLead?.origin} title={dataLead?.origin} />
                            </div>
                            <div className="acciones-panel-lead-name">
                                <label>{dataLead?.candidate_name}</label>
                                <span>{dataLead?.contracting_status || 'Contacto'}</span>
                            </div>
                        </div>
                        <button className="acciones-panel-close" onClick={closeModalAccionesWeb}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    <div className="tabs-acciones-modal">
                        <div
                            className={`tab-accion-modal ${activeTab === 'intentos' ? 'active' : ''}`}
                            onClick={() => handleTabClick('intentos')}>
                            <label>Intentos</label>
                        </div>
                        <div
                            className={`tab-accion-modal ${activeTab === 'tareas' ? 'active' : ''}`}
                            onClick={() => handleTabClick('tareas')}>
                            <label>Tareas</label>
                        </div>
                        <div
                            className={`tab-accion-modal ${activeTab === 'descartar' ? 'active' : ''}`}
                            onClick={() => handleTabClick('descartar')}>
                            <label>Descartar</label>
                        </div>
                        {rol === 'Coordinador' && (
                            <div
                                className={`tab-accion-modal ${activeTab === 'proyecto' ? 'active' : ''}`}
                                onClick={() => handleTabClick('proyecto')}>
                                <label>Proyecto</label>
                            </div>
                        )}
                    </div>
                    <div className="acciones-panel-body">
                    <div className="container-acciones-modal">
                        <div className="tab-container-modal">
                            {activeTab === 'intentos' && <div className="intentos-container-tab">
                                <div className="intentos-item-container">
                                    <label>Titulo:</label>
                                    <span>Una descripción general de la nota.</span>
                                    <input
                                        placeholder="Titulo"
                                        value={newTitle}
                                        onChange={(e) => setNewTitle(e.target.value)}
                                    />
                                </div>
                                <div className="intentos-item-container">
                                    <label>Observaciones:</label>
                                    <span>Una descripción detallada de tu seguimiento.</span>
                                    <textarea
                                        rows="4"
                                        cols="40"
                                        placeholder="Detalles de la nota..."
                                        value={newObservation}
                                        onChange={(e) => setNewObservation(e.target.value)}
                                    ></textarea>
                                </div>
                                <p style={{
                                    cursor: 'pointer',
                                    color: '#5867dd',
                                    textDecoration: 'underline'
                                }} onClick={() => {
                                    handleOption('Intentos');
                                    cambiarEstado();
                                    setSelectedCell(dataLead?.id);
                                    setTimeout(() => {
                                        closeModalAccionesWeb();
                                    }, 100);
                                }}>
                                    Da clic aquí para ver todas las notas creadas
                                </p>
                                <div className="buttons-container-modal">
                                    <button className="btn-acept-modal" onClick={() => {
                                        handleNotesCreate('Intento de contacto')
                                        postActionNote(dataLead?.id, 'Intento de contacto', `${nameMyUser} registró un intento de contacto`)
                                        setAllLeadsFromBackend(prev => prev.map(l =>
                                            l.id === dataLead?.id ? { ...l, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                        ));
                                        setLeads(prev => (prev || []).map(l =>
                                            l.id === dataLead?.id ? { ...l, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                        ));
                                        touchReviewDate(dataLead?.id)
                                        fetchNumeroDeIntentos()
                                        setTimeout(() => {
                                            closeModalAccionesWeb();
                                            setNewTitle('')
                                            setNewObservation('')
                                        }, 1000);
                                    }}>Guardar nota</button>
                                    <button className="btn-cancel-modal" onClick={closeModalAccionesWeb} type="reset">Cancelar</button>
                                </div>
                            </div>}
                            {activeTab === 'tareas' && <div>
                                <div className="body-card2-task">
                                    <div className="body-card2-task-input">
                                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Escribe un nombre para la tarea" />
                                    </div>
                                    <div className="card2-data-container">
                                        <div className="cuadrado inicial">
                                            <label>{primeraLetra}</label>
                                        </div>
                                        <div className="container-data-asesor">
                                            <div className="card2-data-asesor">
                                                <label>Asignada a:</label>
                                                <label>{nameMyUser}</label>
                                            </div>
                                            <div className="card2-data-asesor-date">
                                                <div className="card2-icon-calendar">
                                                    <img src={img2} alt="calendar" />
                                                </div>
                                                <div className="date-data-div2">
                                                    <label>Fecha de término:</label>
                                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tareas-container-tab">
                                        <label>Medio de contacto:</label>
                                        <select value={type_task} onChange={(e) => setType_Task(e.target.value)}>
                                            <option value="Whatsapp">Whatsapp</option>
                                            <option value="Teléfono">Teléfono</option>
                                            <option value="Correo">Correo</option>
                                        </select>
                                    </div>
                                    <div className="div2-textarea">
                                        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descripción..."></textarea>
                                    </div>
                                    <div className="div2-btn">
                                        <button className="addProyecto-btn" onClick={() => {
                                            setTask_Status('Abierta')
                                            handlePosthTasksByLeadRequest();
                                            postActionNote(dataLead?.id, 'Tarea creada', `${nameMyUser} creó la tarea: ${title || 'Sin título'}`)
                                            setAllLeadsFromBackend(prev => prev.map(l =>
                                                l.id === dataLead?.id ? { ...l, open_tasks: (l.open_tasks || 0) + 1 } : l
                                            ));
                                            setLeads(prev => (prev || []).map(l =>
                                                l.id === dataLead?.id ? { ...l, open_tasks: (l.open_tasks || 0) + 1 } : l
                                            ));
                                            touchReviewDate(dataLead?.id)
                                            fetchDataForLead()
                                            setTimeout(() => {
                                                fetchAllLeadsFromBackend();
                                                closeModalAccionesWeb();
                                            }, 1000);
                                        }}>Crear tarea</button>
                                    </div>
                                </div>
                            </div>}
                            {activeTab === 'descartar' && <div>
                                <div className="title-descartar-tab">
                                    <label>Motivo:</label>
                                    <span>Menciona porqué se descarta.</span>
                                </div>
                                <div className="options-descartar-tab">
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="No cumple con el perfil"
                                            checked={newObservation === 'No cumple con el perfil'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> No cumple con el perfil</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="No tiene interés"
                                            checked={newObservation === 'No tiene interés'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> No tiene interés</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="Número inválido"
                                            checked={newObservation === 'Número inválido'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> Número inválido</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="No contesta la llamada"
                                            checked={newObservation === 'No contesta la llamada'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> No contesta la llamada</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="Otra razón"
                                            checked={newObservation === 'Otra razón'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> Otra razón</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="Contacto repetido"
                                            checked={newObservation === 'Contacto repetido'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> Contacto repetido</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="El contacto es Broker"
                                            checked={newObservation === 'El contacto es Broker'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> El contacto es Broker</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="No cuenta con el presupuesto necesario"
                                            checked={newObservation === 'No cuenta con el presupuesto necesario'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> No cuenta con el presupuesto necesario</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="Contacto falso"
                                            checked={newObservation === 'Contacto falso'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> Contacto falso</label>
                                    </div>
                                </div>
                                <div className="buttons-container-modal">
                                    <button className="btn-danger-modal" onClick={async () => {
                                        const motivoDescarte = newObservation || 'sin motivo especificado';
                                        try {
                                            await handlePatchDiscard();
                                            handleNotesCreate('Descartado');
                                            postActionNote(dataLead?.id, 'Contacto descartado', `${nameMyUser} descartó el contacto. Motivo: ${motivoDescarte}`);
                                            setAllLeadsFromBackend(prev => prev.map(l =>
                                                l.id === dataLead?.id ? { ...l, discard: true, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                            ));
                                            closeModalAccionesWeb();
                                        } catch (error) {
                                            console.error('Error al descartar:', error);
                                        }
                                    }}>Descartar</button>
                                    <button className="btn-cancel-modal" onClick={closeModalAccionesWeb} type="reset">Cancelar</button>
                                </div>
                            </div>}
                            {activeTab === 'proyecto' && (rol === 'Coordinador' || rol === 'Administrador') && (() => {
                                const sameCompanyProjects = (() => {
                                    if (!projects || !dataLead?.vacant_code) return [];
                                    const company = projects.find(c =>
                                        c.projects.some(p => p.vacant_code === dataLead.vacant_code)
                                    );
                                    return company?.projects ?? [];
                                })();
                                return (
                                    <div className="intentos-item-container">
                                        <label>Mover a proyecto</label>
                                        <select
                                            defaultValue={dataLead?.vacant_code}
                                            onChange={(e) => handleVacantCodeChange(e.target.value, dataLead?.id)}
                                            style={{ width: '90%', padding: '8px', borderRadius: '8px', border: '1px solid #dae2ea' }}
                                        >
                                            {sameCompanyProjects.map(p => (
                                                <option key={p.vacant_code} value={p.vacant_code}>
                                                    {p.vacant_name}
                                                </option>
                                            ))}
                                        </select>
                                        <span style={{ fontSize: '11px', color: '#a7b1c2', marginTop: '6px' }}>
                                            Al seleccionar un proyecto distinto, el contacto se moverá automáticamente.
                                        </span>
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                    </div>
                </div>
                <Modal isOpen={isModalOpenOmitirDiscard} onClose={closeModalOmitirDiscard}>
                    <div className="modal-title">
                        <label>Omitir descartado</label>
                    </div>
                    <div className="main-omitDiscard-modal">
                        <div className="container-omitir-discard-modal">
                            <label id="uno">Motivo:</label>
                            <label id="dos">Explica porqué reincorporarás a este contacto al proceso de selección.</label>
                            <textarea rows="4" cols="40"></textarea>
                        </div>
                    </div>
                    <div className="buttons-container-modal">
                        <button className="btn-cancel-modal" onClick={closeModalOmitirDiscard} type="reset">Cancelar</button>
                        <button className="btn-acept-modal" onClick={() => {
                            handlePatchSeleccion()
                            setTimeout(() => {
                                closeModalOmitirDiscard();
                            }, 1000);
                        }}>Aceptar</button>
                    </div>
                </Modal>
                <Modal isOpen={isModalOpenFilterPeriod} onClose={closeModalFilterPeriod}>
                    <div className="modal-title">
                        <label>Periodo por fechas</label>
                    </div>
                    <div className="container-download-main-modal">
                        <div className="container-download-lead-modal">
                            <div className="filter-date-period">
                                <div className="card2-data-asesor-date">
                                    <div className="card2-icon-calendar">
                                        <img src={img2} alt="calendar" />
                                    </div>
                                    <div className="date-data-div2">
                                        <label>Desde:</label>
                                        <input
                                            type="date"
                                            onChange={(e) => setFechaInicio(new Date(e.target.value))}
                                        />
                                    </div>
                                </div>
                                <div className="card2-data-asesor-date">
                                    <div className="card2-icon-calendar">
                                        <img src={img2} alt="calendar" />
                                    </div>
                                    <div className="date-data-div2">
                                        <label>Hasta:</label>
                                        <input
                                            type="date"
                                            onChange={(e) => setFechaFin(new Date(e.target.value))}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-buttons-download-lead-movil">
                        <button
                            className="btn-cancel-modal"
                            onClick={() => {
                                setPeriodo("00")
                                closeModalFilterPeriod()
                            }}
                            type="reset"
                        >Cancelar</button>
                        <button
                            className="btn-acept-modal"
                            onClick={() => {
                                filtrarLeadsPorFecha()
                                closeModalFilterPeriod()
                            }}
                        >Aceptar</button>
                    </div>
                </Modal>
                <Modal isOpen={isModalOpenTaskByLead} onClose={closeModalTaskByLead}>
                    <div className="title-modal-perfilContacto">
                        <div className="cabecera card2">
                            <div className="head-task-label">
                                <label>CREAR UNA TAREA</label>
                            </div>
                        </div>
                    </div>
                    <div className="body-card2-task">
                        <div className="body-card2-task-input">
                            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Escribe un nombre para la tarea" />
                        </div>
                        <div className="card2-data-container">
                            <div className="cuadrado inicial">
                                <label>{primeraLetra}</label>
                            </div>
                            <div className="container-data-asesor">
                                <div className="card2-data-asesor">
                                    <label>Asignada a:</label>
                                    <label>{nameMyUser}</label>
                                </div>
                                <div className="card2-data-asesor-date">
                                    <div className="card2-icon-calendar">
                                        <img src={img2} alt="calendar" />
                                    </div>
                                    <div className="date-data-div2">
                                        <label>Fecha de término:</label>
                                        <input type="date" value={expiration} onChange={handleDate2Change} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="div2-textarea">
                            <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descripción..."></textarea>
                        </div>
                        <div className="div2-btn">
                            <button className="addProyecto-btn" onClick={() => {
                                setTask_Status('Abierta')
                                handlePosthTasksByLeadRequest();
                                setAllLeadsFromBackend(prev => prev.map(l =>
                                    l.id === dataLead?.id ? { ...l, open_tasks: (l.open_tasks || 0) + 1 } : l
                                ));
                                setLeads(prev => (prev || []).map(l =>
                                    l.id === dataLead?.id ? { ...l, open_tasks: (l.open_tasks || 0) + 1 } : l
                                ));
                                touchReviewDate(dataLead?.id)
                                // Actualizar la tabla después de agregar tarea
                                setTimeout(() => {
                                    fetchAllLeadsFromBackend();
                                    closeModalTaskByLead();
                                }, 1000);
                            }}>Crear tarea</button>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isModalOpen4} onClose={closeModal4}>
                    <div className="modal-title">
                        <label>Descartar contacto</label>
                    </div>
                    <div className="container-descartar-modal-perfilContacto container-descartar-modal-perfilContacto-movil">
                        <div className="title-descartar-tab">
                            <label>Motivo:</label>
                            <span>Menciona porqué se descarta.</span>
                        </div>
                        <div className="options-descartar-tab">
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="No cumple con el perfil"
                                    checked={newObservation === 'No cumple con el perfil'}
                                    onChange={handleOpcionChange}
                                />
                                <label> No cumple con el perfil</label>
                            </div>
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="No tiene interés"
                                    checked={newObservation === 'No tiene interés'}
                                    onChange={handleOpcionChange}
                                />
                                <label> No tiene interés</label>
                            </div>
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="Número inválido"
                                    checked={newObservation === 'Número inválido'}
                                    onChange={handleOpcionChange}
                                />
                                <label> Número inválido</label>
                            </div>
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="No contesta la llamada"
                                    checked={newObservation === 'No contesta la llamada'}
                                    onChange={handleOpcionChange}
                                />
                                <label> No contesta la llamada</label>
                            </div>
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="Otra razón"
                                    checked={newObservation === 'Otra razón'}
                                    onChange={handleOpcionChange}
                                />
                                <label> Otra razón</label>
                            </div>
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="Contacto repetido"
                                    checked={newObservation === 'Contacto repetido'}
                                    onChange={handleOpcionChange}
                                />
                                <label> Contacto repetido</label>
                            </div>
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="El contacto es Broker"
                                    checked={newObservation === 'El contacto es Broker'}
                                    onChange={handleOpcionChange}
                                />
                                <label> El contacto es Broker</label>
                            </div>
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="No cuenta con el presupuesto necesario"
                                    checked={newObservation === 'No cuenta con el presupuesto necesario'}
                                    onChange={handleOpcionChange}
                                />
                                <label> No cuenta con el presupuesto necesario</label>
                            </div>
                            <div className="item-descartar-tab">
                                <input
                                    type="radio"
                                    name="descarte"
                                    value="Contacto falso"
                                    checked={newObservation === 'Contacto falso'}
                                    onChange={handleOpcionChange}
                                />
                                <label> Contacto falso</label>
                            </div>
                        </div>
                        <div className="buttons-container-modal">
                            <button className="btn-danger-modal" onClick={async () => {
                                const motivoDescarte = newObservation || 'sin motivo especificado';
                                try {
                                    await handlePatchDiscard();
                                    handleNotesCreate('Descartado');
                                    postActionNote(dataLead?.id, 'Contacto descartado', `${nameMyUser} descartó el contacto. Motivo: ${motivoDescarte}`);
                                    setAllLeadsFromBackend(prev => prev.map(l =>
                                        l.id === dataLead?.id ? { ...l, discard: true, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                    ));
                                    setTimeout(() => {
                                        closeModal4();
                                        navigate('/Contactos');
                                    }, 1000);
                                } catch (error) {
                                    console.error('Error al descartar:', error);
                                }
                            }}>Descartar</button>
                            <button className="btn-cancel-modal" onClick={closeModal4} type="reset">Cancelar</button>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isModalOpenFiltros} onClose={closeModalFiltros}>
                    <div className="modal-title">
                        <label>Filtros</label>
                    </div>
                    <div className="filtros">
                        <div className="filter">
                            <label>PERIODO</label>
                            <select value={periodo} onChange={handleSelectPeriodo}>
                                <option value="00">Todos</option>
                                <option value="semana">Esta semana</option>
                                <option value="15_dias">Ultimos 15 dias</option>
                                <option value="30_dias">Ultimos 30 dias</option>
                                <option value="90_dias">Ultimos 90 dias</option>
                                <option value="otro">Otro...</option>
                            </select>
                        </div>
                        <div className="filter">
                            <label>SEGUIMIENTO</label>
                            <select value={seguimiento} onChange={handleSelectSeguimiento}>
                                <option value="contactos">Total</option>
                                <option value="seguimiento">Seguimiento</option>
                                <option value="descartados">Descartados</option>
                            </select>
                        </div>
                        {rol === 'Asesor' && <div className="filter">
                            <label>ASESOR</label>
                            <input className="asesor-filter-input" defaultValue={getCurrentUserName()} disabled />
                        </div>}
                        {(rol === 'Coordinador' || rol === 'Supervisor') && <div className="filter">
                            <label>ASESOR</label>
                            <select value={recruiter_id} onChange={handleSelectAsesor}>
                                <option value="">Todos</option>
                                <option value="null">Sin asignar</option>
                                {listaUsers?.map((asesor) => (
                                    <option key={asesor.id} value={asesor.id}>
                                        {asesor.first_name} {asesor.last_name}
                                    </option>
                                ))}
                            </select>
                        </div>}
                        <div className="filter">
                            <label>ETIQUETA</label>
                            <select value={tagUrl} onChange={handleSelectChange}>
                                <option value="todas">Todas</option>
                                <option value="Seguimiento">Seguimiento</option>
                                <option value="Llamar más adelante">Llamar más adelante</option>
                                <option value="No contesta">No contesta</option>
                                <option value="Apartado">Apartado</option>
                                <option value="No comprará">No comprará</option>
                                <option value="">Sin etiqueta</option>
                            </select>
                        </div><div className="filter">
                            <label>ORIGEN</label>
                            <select value={originUrl} onChange={handleSelectOrigin}>
                                <option value="todos">Todos</option>
                                <optgroup label="Medios Digitales">
                                    <option value="Base_Datos">Base de Datos</option>
                                    <option value="Facebook">Facebook</option>
                                    <option value="Facebook_Desktop_Feed">Facebook Ads</option>
                                    <option value="Google">Google</option>
                                    <option value="Google Ads">Google Ads</option>
                                    <option value="Instagram">Instagram</option>
                                    <option value="Instagram Ads">Instagram Ads</option>
                                    <option value="LinkedIn">LinkedIn</option>
                                    <option value="Whatsapp">Whatsapp</option>
                                    <option value="Tiktok">Tiktok</option>
                                    <option value="Página web">Página web</option>
                                    <option value="Redes sociales">Redes sociales</option>
                                </optgroup>
                                <optgroup label="Medios Tradicionales">
                                    <option value="Broker">Broker o Asesor Externo</option>
                                    <option value="Cambaceo">Cambaceo</option>
                                    <option value="Contacto Directo">Contacto Directo</option>
                                    <option value="Espectacular">Espectacular / Lonas</option>
                                    <option value="Inmobiliaria Externa">Inmobiliaria Externa</option>
                                    <option value="Periodico">Periódico</option>
                                    <option value="Radio">Radio</option>
                                    <option value="Recompra">Recompra</option>
                                    <option value="Revista">Revista</option>
                                    <option value="Referidos">Referidos</option>
                                    <option value="Señaletica">Señalética</option>
                                    <option value="Telefono">Teléfono</option>
                                    <option value="Televisión">Televisión</option>
                                    <option value="Volante">Volante</option>
                                    <option value="Walk-in">Walk-in</option>
                                </optgroup>
                                <optgroup label="Portales Inmobiliarios">
                                    <option value="Inmuebles 24">Inmuebles 24</option>
                                    <option value="Lamudi">Lamudi</option>
                                    <option value="Metros cúbicos">Metros cúbicos</option>
                                    <option value="Propiedades.com">Propiedades.com</option>
                                    <option value="Segundamano">Segundamano</option>
                                    <option value="Tu Hogar México">Tu Hogar México</option>
                                    <option value="Vivanuncios">Vivanuncios</option>
                                </optgroup>
                            </select>
                        </div><div className="filter">
                            <label>VISITÓ DESARROLLO</label>
                            <select value={visited} onChange={handleSelectVisited}>
                                <option value="Todos">Todos</option>
                                <option value="true">Si</option>
                                <option value="false">No</option>
                            </select>
                        </div>
                        <div className="filter filter--emojis">
                            <label>EMOJIS</label>
                            <div className="emoji-filter-row">
                                {[
                                    { key: 'feliz',     icon: '😊', label: 'Feliz',     range: '0-7 días' },
                                    { key: 'serio',     icon: '😐', label: 'Serio',     range: '8-13 días' },
                                    { key: 'triste',    icon: '😞', label: 'Triste',    range: '14-21 días' },
                                    { key: 'congelado', icon: '🥶', label: 'Congelado', range: '22-90 días' },
                                    { key: 'dormido',   icon: '😴', label: 'Dormido',   range: '+90 días' },
                                ].map(({ key, icon, label, range }) => (
                                    <button
                                        key={key}
                                        type="button"
                                        title={range}
                                        className={`emoji-filter-btn${emojiFilter === key ? ' emoji-filter-btn--active' : ''}`}
                                        onClick={() => setEmojiFilter(emojiFilter === key ? null : key)}
                                    >
                                        <span className="emoji-filter-icon">{icon}</span>
                                        <span className="emoji-filter-label">{label}</span>
                                        <span className="emoji-filter-count">{emojiCounts[key]}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="buttons-container-modal">
                        <button className="btn-cancel-modal" onClick={closeModalFiltros} type="reset">Cancelar</button>
                        <button className="btn-reset-modal" onClick={resetAllFilters} type="button">Limpiar filtros</button>
                        <button className="btn-acept-modal" onClick={closeModalFiltros} >Buscar</button>
                    </div>
                </Modal>
                {/* ---Movil--- */}
                <Modal isOpen={isModalOpenAddMovil} onClose={closeModalAddMovil}>
                    <div className="modal-title">
                        <label>Agregar Contacto</label>
                    </div>
                    <div className="container-addlead-modal">
                        <label>Nombre</label>
                        <input
                            placeholder="Escribe el nombre del contacto"
                            value={modalCandidateName}
                            onChange={handleNombreChange}
                        />
                        {candidate_nameError && <span className="error-message">{candidate_nameError}</span>}
                        <label>Fecha de registro</label>
                        <input type="date" value={currentDate} readOnly />
                        <label>Correo</label>
                        <input
                            placeholder="Escribe el email del contacto"
                            value={modalEmail}
                            onChange={handleCorreoChange}
                        />
                        {emailError && <span className="error-message">{emailError}</span>}
                        <label>Teléfono</label>
                        <input
                            placeholder="Escribe el teléfono del contacto"
                            value={modalPhoneNumber}
                            onChange={handleTelefonoChange}
                            maxLength={10}
                        />
                        {phone_numberError && <span className="error-message">{phone_numberError}</span>}
                        <label>Edad</label>
                        <select value={modalAge} onChange={handleEdadChange}>
                            <option value="No estoy seguro">No estoy seguro</option>
                            <option value="18 a 20">18 a 20</option>
                            <option value="21 a 25">21 a 25</option>
                            <option value="26 a 30">26 a 30</option>
                            <option value="31 a 35">31 a 35</option>
                            <option value="36 a 40">36 a 40</option>
                            <option value="41 a 45">41 a 45</option>
                            <option value="46 a 50">46 a 50</option>
                            <option value="51 a 55">51 a 55</option>
                            <option value="Más de 60">Más de 60</option>
                        </select>
                        {ageError && <span className="error-message">{ageError}</span>}
                        <label>Estado civil</label>
                        <select value={modalMaritalStatus} onChange={handleCivilChange}>
                            <option value=""></option>
                            <option value="Soltero">Soltero</option>
                            <option value="Casado">Casado</option>
                            <option value="Divorciado">Divorciado</option>
                            <option value="Viudo">Viudo</option>
                        </select>
                        <label>Lugar de residencia</label>
                        <input
                            name="ciudad"
                            value={modalCity}
                            onChange={handleCiudadChange}
                        />
                        {cityError && <span className="error-message">{cityError}</span>}
                        <label>Etapa de vida</label>
                        <select value={modalLifeStatus} onChange={handleLifeChange}>
                            <option value="null"></option>
                            <option value="Joven soltero (21-35)">Joven soltero (21-35)</option>
                            <option value="Adulto soltero (36+">Adulto soltero (36+)</option>
                            <option value="Sin hijos">Sin hijos</option>
                            <option value="Familia pequeña (Hijos de 0-10)">Familia pequeña (Hijos de 0-10)</option>
                            <option value="Familia joven (Hijos de 11-20)">Familia joven (Hijos de 11-20)</option>
                            <option value="Familia grande (21+)">Familia grande (21+)</option>
                            <option value="Divorciado con hijos (21+)">Divorciado con hijos (21+)</option>
                            <option value="Adulto mayor (51+)">Adulto mayor (51+)</option>
                        </select>
                        <label>Género</label>
                        <select value={modalGender} onChange={handleGeneroChange}>
                            <option value=""></option>
                            <option value="Hombre">Hombre</option>
                            <option value="Mujer">Mujer</option>
                            <option value="No Binario">No Binario</option>
                            <option value="No definido">No definido</option>
                        </select>
                        {genderError && <span className="error-message">{genderError}</span>}
                        <label>Rázon de compra</label>
                        <select value={modalPurchaseReason} onChange={handleReasonChange}>
                            <option value=""></option>
                            <option value="Vivir">Vivir</option>
                            <option value="Renta">Renta</option>
                            <option value="Inversión">Inversión</option>
                        </select>
                        <label>Tiempo de compra</label>
                        <select value={modalPurchaseTime} onChange={handleCompraChange}>
                            <option value="No estoy seguro">No estoy seguro</option>
                            <option value="Tres meses">Tres meses</option>
                            <option value="Seis meses">Seis meses</option>
                            <option value="Un año">Un año</option>
                        </select>
                        <label>Presupuesto aproximado</label>
                        <select value={modalBudget} onChange={handlePresupuestoChange}>
                            <option value="Sin respuesta">Sin respuesta</option>
                            <option value="$400,000 a $490,000">$400,000 a $490,000</option>
                            <option value="$500,000 a $780,000">$500,000 a $780,000</option>
                            <option value="$790,000 a $890,000">$790,000 a $890,000</option>
                        </select>
                        <label>Forma de pago</label>
                        <select value={modalPaymentType} onChange={handleTipoPagoChange}>
                            <option value="null"></option>
                            <option value="Contado Riguroso">Contado Riguroso</option>
                            <option value="Contado Plazo">Contado Plazo</option>
                            <option value="Crédito Infonavit">Crédito Infonavit</option>
                            <option value="Crédito Bancario">Crédito Bancario</option>
                            <option value="Fovissste">Fovissste</option>
                            <option value="Fovissste Aliados">Fovissste Aliados</option>
                            <option value="Fovissste Para Todos">Fovissste Para Todos</option>
                            <option value="Infonavit Total">Infonavit Total</option>
                            <option value="Apoyo Infonavit">Apoyo Infonavit</option>
                            <option value="Cofinavit">Cofinavit</option>
                            <option value="CFE">CFE</option>
                            <option value="Telmex">Telmex</option>
                            <option value="Cofinanciamiento">Cofinanciamiento</option>
                            <option value="Crédito Interno">Crédito Interno</option>
                            <option value="Cajas de Ahorro">Cajas de Ahorro</option>
                            <option value="Otro">Otro</option>
                        </select>
                        <label>Medio de contacto</label>
                        <select value={modalContactType} onChange={handleTipoChange}>
                            <option value=""></option>
                            <option value="Teléfono">Teléfono</option>
                            <option value="Correo">Correo</option>
                            <option value="Whatsapp">Whatsapp</option>
                        </select>
                        {contact_typeError && <span className="error-message">{contact_typeError}</span>}
                        <label>Origen del contacto</label>
                        <select value={modalOrigin} onChange={handleOrigenChange}>
                            <option value=""></option>
                            <optgroup label="Medios Digitales">
                                <option value="Base_Datos">Base de Datos</option>
                                <option value="Facebook">Facebook</option>
                                <option value="Facebook_Desktop_Feed">Facebook Ads</option>
                                <option value="Google">Google</option>
                                <option value="Instagram">Instagram</option>
                                <option value="Whatsapp">Whatsapp</option>
                                <option value="Tiktok">Tiktok</option>
                                <option value="Página web">Pagina web</option>
                                <option value="Redes sociales">Redes sociales</option>
                            </optgroup>
                            <optgroup label="Medios Tradicionales">
                                <option value="Broker">Broker o Asesor Externo</option>
                                <option value="Cambaceo">Cambaceo</option>
                                <option value="Contacto Directo">Contacto Directo</option>
                                <option value="Espectacular">Espectacular</option>
                                <option value="Inmobiliaria Externa">Inmobiliaria Externa</option>
                                <option value="Lonas">Lonas</option>
                                <option value="Periodico">Periodico</option>
                                <option value="Radio">Radio</option>
                                <option value="Recompra">Recompra</option>
                                <option value="Revista">Revista</option>
                                <option value="Referidos">Referidos</option>
                                <option value="Señaletica">Señaletica</option>
                                <option value="Telefono">Telefono</option>
                                <option value="Televisión">Televisión</option>
                                <option value="Volante">Volante</option>
                                <option value="Walk-in">Walk-in</option>
                            </optgroup>
                            <optgroup label="Portales Inmobiliarios">
                                <option value="Inmuebles 24">Inmuebles 24</option>
                                <option value="Lamudi">Lamudi</option>
                                <option value="Metros cúbicos">Metros cúbicos</option>
                                <option value="Propiedades.com">Propiedades.com</option>
                                <option value="Segundamano">Segundamano</option>
                                <option value="Tu Hogar México">Tu Hogar México</option>
                                <option value="Vivanuncios">Vivanuncios</option>
                            </optgroup>
                        </select>
                        {originError && <span className="error-message">{originError}</span>}
                        <label>Estatus</label>
                        <select value={modalContractingStatus} onChange={handleEstatusChange} disabled={rol?.toLowerCase() === 'supervisor'}>
                            <option value=""></option>
                            <option value="Contacto">Contacto</option>
                            <option value="Calificado">Calificado</option>
                            <option value="Cita">Cita</option>
                            <option value="Visita">Visita</option>
                            <option value="Potencial">Potencial</option>
                            <option value="Cierre">Cierre</option>
                        </select>
                        {contracting_statusError && <span className="error-message">{contracting_statusError}</span>}
                    </div>
                    {contextApiErrorMessage && (
                        <div style={{
                            padding: '10px',
                            margin: '10px 20px',
                            backgroundColor: '#ffebee',
                            border: '1px solid #f44336',
                            borderRadius: '4px',
                            color: '#d32f2f',
                            fontSize: '14px',
                            textAlign: 'center'
                        }}>
                            ❌ {contextApiErrorMessage}
                        </div>
                    )}
                    <div className="buttons-container-modal">
                        <button className="btn-cancel-modal" onClick={closeModalAddMovil} type="reset">Cancelar</button>
                        <button className="btn-acept-modal" onClick={() => {
                            if (!modalCandidateName) {
                                setCandidateNameError('Este campo es obligatorio');
                            } else {
                                setCandidateNameError('');
                            }

                            // Email and phone are optional if at least one is provided
                            if (!modalEmail && !modalPhoneNumber) {
                                setEmailError('Debes proporcionar al menos un correo o teléfono');
                                setPhoneNumberError('Debes proporcionar al menos un correo o teléfono');
                            } else {
                                setEmailError('');
                                setPhoneNumberError('');
                            }

                            if (!modalAge) {
                                setAgeError('Este campo es obligatorio');
                            } else {
                                setAgeError('');
                            }

                            if (!modalCity) {
                                setCityError('Este campo es obligatorio');
                            } else {
                                setCityError('');
                            }

                            if (!modalGender) {
                                setGenderError('Este campo es obligatorio');
                            } else {
                                setGenderError('');
                            }

                            if (!modalContactType) {
                                setContactTypeError('Este campo es obligatorio');
                            } else {
                                setContactTypeError('');
                            }

                            if (!modalOrigin) {
                                setOriginError('Este campo es obligatorio');
                            } else {
                                setOriginError('');
                            }

                            if (!modalContractingStatus) {
                                setContractingStatusError('Este campo es obligatorio');
                            } else {
                                setContractingStatusError('');
                            }

                            if (modalCandidateName && (modalEmail || modalPhoneNumber) && modalAge && modalCity && modalGender && modalContactType && modalOrigin && modalContractingStatus) {
                                const leadData = {
                                    candidate_name: modalCandidateName,
                                    email: modalEmail,
                                    phone_number: modalPhoneNumber,
                                    age: modalAge,
                                    marital_status: modalMaritalStatus,
                                    city: modalCity,
                                    life_status: modalLifeStatus,
                                    gender: modalGender,
                                    purchase_reason: modalPurchaseReason,
                                    purchase_time: modalPurchaseTime,
                                    budget: modalBudget,
                                    payment_type: modalPaymentType,
                                    contact_type: modalContactType,
                                    origin: modalOrigin,
                                    contracting_status: modalContractingStatus,
                                    interest,
                                    initial_comment,
                                    vacant_code
                                };

                                // Lógica de asignación automática de recruiter según el rol
                                if (rol && rol.toLowerCase() === 'asesor') {
                                    leadData.recruiter = Id;
                                } else if (rol && (rol.toLowerCase() === 'coordinador' || rol.toLowerCase() === 'administrador' || rol.toLowerCase() === 'supervisor')) {
                                    leadData.recruiter = null; // Sin asignar
                                }

                                setUpLead(leadData);
                                setBtnCreateLead(true);
                            }
                        }}>Aceptar</button>
                    </div>
                </Modal>
                <Modal isOpen={isModalOpenAcciones} onClose={closeModalAcciones}>
                    <div className="modal-title">
                        <label>Acciones</label>
                    </div>
                    <div className="container-acciones-modal">
                        <div className="tabs-acciones-modal">
                            <div
                                className={`tab-accion-modal ${activeTab === 'intentos' ? 'active' : ''}`}
                                onClick={() => handleTabClick('intentos')}>
                                <label>Intentos</label>
                            </div>
                            <div
                                className={`tab-accion-modal ${activeTab === 'tareas' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tareas')}>
                                <label>Tareas</label>
                            </div>
                            <div
                                className={`tab-accion-modal ${activeTab === 'descartar' ? 'active' : ''}`}
                                onClick={() => handleTabClick('descartar')}>
                                <label>Descartar</label>
                            </div>
                            {rol === 'Coordinador' && (
                                <div
                                    className={`tab-accion-modal ${activeTab === 'proyecto' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('proyecto')}>
                                    <label>Proyecto</label>
                                </div>
                            )}
                        </div>
                        <div className="tab-container-modal">
                            {activeTab === 'intentos' && <div className="intentos-container-tab">
                                <div className="intentos-item-container">
                                    <label>Titulo:</label>
                                    <span>Una descripción general de la nota.</span>
                                    <input
                                        placeholder="Titulo"
                                        value={newTitle}
                                        onChange={(e) => setNewTitle(e.target.value)}
                                    />
                                </div>
                                <div className="intentos-item-container">
                                    <label>Observaciones:</label>
                                    <span>Una descripción detallada de tu seguimiento.</span>
                                    <textarea
                                        rows="4"
                                        cols="40"
                                        placeholder="Detalles de la nota..."
                                        value={newObservation}
                                        onChange={(e) => setNewObservation(e.target.value)}
                                    ></textarea>
                                </div>
                                <p style={{
                                    cursor: 'pointer',
                                    color: '#5867dd',
                                    textDecoration: 'underline'
                                }} onClick={() => {
                                    handleOption('Intentos');
                                    cambiarEstado();
                                    setSelectedCell(dataLead?.id);
                                    setTimeout(() => {
                                        closeModalAccionesWeb();
                                    }, 100);
                                }}>
                                    Da clic aquí para ver todas las notas creadas
                                </p>
                                <div className="buttons-container-modal">
                                    <button className="btn-acept-modal" onClick={() => {
                                        handleNotesCreate('Intento de contacto')
                                        setAllLeadsFromBackend(prev => prev.map(l =>
                                            l.id === dataLead?.id ? { ...l, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                        ));
                                        setLeads(prev => (prev || []).map(l =>
                                            l.id === dataLead?.id ? { ...l, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                        ));
                                        touchReviewDate(dataLead?.id)
                                        setTimeout(() => {
                                            closeModalAccionesWeb();
                                            setNewTitle('')
                                            setNewObservation('')
                                        }, 1000);
                                    }}>Guardar nota</button>
                                    <button className="btn-cancel-modal" onClick={closeModalAccionesWeb} type="reset">Cancelar</button>
                                </div>
                            </div>}
                            {activeTab === 'tareas' && <div>
                                <div className="tareas-container-tab">
                                    <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Escribe un nombre para la tarea" />
                                    <label>Asignado a:</label>
                                    <span>{nameMyUser}</span>
                                    <label>Fecha de termino:</label>
                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                    <label>Medio de contacto:</label>
                                    <select value={type_task} onChange={(e) => setType_Task(e.target.value)}>
                                        <option value="Whatsapp">Whatsapp</option>
                                        <option value="Teléfono">Teléfono</option>
                                        <option value="Correo">Correo</option>
                                    </select>
                                    <textarea rows="4" cols="40" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descripción..."></textarea>
                                </div>
                                <div className="buttons-container-modal">
                                    <button className="btn-acept-modal" onClick={() => {
                                        setTask_Status('Abierta')
                                        handlePosthTasksByLeadRequest();
                                        setAllLeadsFromBackend(prev => prev.map(l =>
                                            l.id === dataLead?.id ? { ...l, open_tasks: (l.open_tasks || 0) + 1 } : l
                                        ));
                                        setLeads(prev => (prev || []).map(l =>
                                            l.id === dataLead?.id ? { ...l, open_tasks: (l.open_tasks || 0) + 1 } : l
                                        ));
                                        touchReviewDate(dataLead?.id)
                                        // Actualizar la tabla después de agregar tarea
                                        setTimeout(() => {
                                            fetchAllLeadsFromBackend();
                                            closeModalAcciones();
                                        }, 1000);
                                    }}>Crear tarea</button>
                                </div>
                            </div>}
                            {activeTab === 'descartar' && <div>
                                <div className="title-descartar-tab">
                                    <label>Motivo:</label>
                                    <span>Menciona porqué se descarta.</span>
                                </div>
                                <div className="options-descartar-tab">
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="No cumple con el perfil"
                                            checked={newObservation === 'No cumple con el perfil'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> No cumple con el perfil</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="No tiene interés"
                                            checked={newObservation === 'No tiene interés'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> No tiene interés</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="Número inválido"
                                            checked={newObservation === 'Número inválido'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> Número inválido</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="No contesta la llamada"
                                            checked={newObservation === 'No contesta la llamada'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> No contesta la llamada</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="Otra razón"
                                            checked={newObservation === 'Otra razón'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> Otra razón</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="Contacto repetido"
                                            checked={newObservation === 'Contacto repetido'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> Contacto repetido</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="El contacto es Broker"
                                            checked={newObservation === 'El contacto es Broker'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> El contacto es Broker</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="No cuenta con el presupuesto necesario"
                                            checked={newObservation === 'No cuenta con el presupuesto necesario'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> No cuenta con el presupuesto necesario</label>
                                    </div>
                                    <div className="item-descartar-tab">
                                        <input
                                            type="radio"
                                            name="descarte"
                                            value="Contacto falso"
                                            checked={newObservation === 'Contacto falso'}
                                            onChange={handleOpcionChange}
                                        />
                                        <label> Contacto falso</label>
                                    </div>
                                </div>
                                <div className="buttons-container-modal">
                                    <button className="btn-danger-modal" onClick={async () => {
                                        const motivoDescarte = newObservation || 'sin motivo especificado';
                                        try {
                                            await handlePatchDiscard();
                                            handleNotesCreate('Descartado');
                                            postActionNote(dataLead?.id, 'Contacto descartado', `${nameMyUser} descartó el contacto. Motivo: ${motivoDescarte}`);
                                            setAllLeadsFromBackend(prev => prev.map(l =>
                                                l.id === dataLead?.id ? { ...l, discard: true, contact_attempts: (l.contact_attempts || 0) + 1 } : l
                                            ));
                                            closeModalAccionesWeb();
                                        } catch (error) {
                                            console.error('Error al descartar:', error);
                                        }
                                    }}>Descartar</button>
                                    <button className="btn-cancel-modal" onClick={closeModalAccionesWeb} type="reset">Cancelar</button>
                                </div>
                            </div>}
                            {activeTab === 'proyecto' && (rol === 'Coordinador' || rol === 'Administrador') && (() => {
                                const sameCompanyProjects = (() => {
                                    if (!projects || !dataLead?.vacant_code) return [];
                                    const company = projects.find(c =>
                                        c.projects.some(p => p.vacant_code === dataLead.vacant_code)
                                    );
                                    return company?.projects ?? [];
                                })();
                                return (
                                    <div className="intentos-item-container">
                                        <label>Mover a proyecto</label>
                                        <select
                                            defaultValue={dataLead?.vacant_code}
                                            onChange={(e) => handleVacantCodeChange(e.target.value, dataLead?.id)}
                                            style={{ width: '90%', padding: '8px', borderRadius: '8px', border: '1px solid #dae2ea' }}
                                        >
                                            {sameCompanyProjects.map(p => (
                                                <option key={p.vacant_code} value={p.vacant_code}>
                                                    {p.vacant_name}
                                                </option>
                                            ))}
                                        </select>
                                        <span style={{ fontSize: '11px', color: '#a7b1c2', marginTop: '6px' }}>
                                            Al seleccionar un proyecto distinto, el contacto se moverá automáticamente.
                                        </span>
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isModalOpenDownLeadMovil} onClose={closeModalDownLeadMovil}>
                    <div className="modal-title">
                        <label>Descargar contactos</label>
                    </div>
                    <div className="container-download-main-modal">
                        <div className="container-download-lead-modal">
                            <span>Selecciona los contactos que deseas descargar:</span>
                            <div className="options-download-lead-modal">
                                <input type="radio" name="download" value='1' />
                                <span> Contactos filtrados</span>
                            </div>
                            <div className="options-download-lead-modal">
                                <input type="radio" name="download" value='2' />
                                <span> Todos los contactos</span>
                            </div>
                        </div>
                    </div>
                    <div className="buttons-container-modal">
                        <button className="btn-cancel-modal" onClick={closeModalDownLeadMovil} type="reset">Cancelar</button>
                        <button className="btn-acept-modal">Aceptar</button>
                    </div>
                </Modal>
                <Modal isOpen={isModalOpenFilter} onClose={closeModalFilter}>
                    <div className="modal-title">
                        <label>Filtros</label>
                    </div>
                    <div className="container-filter-leads-modal">
                        <div className="item-filter-leads-modal">
                            <label>PERIODO</label>
                            <select value={periodo} onChange={handleSelectPeriodo}>
                                <option value="00">Todos</option>
                                <option value="semana">Esta semana</option>
                                <option value="15_dias">Ultimos 15 dias</option>
                                <option value="30_dias">Ultimos 30 dias</option>
                                <option value="90_dias">Ultimos 90 dias</option>
                                <option value="otro">Otro...</option>
                            </select>
                        </div>
                        <div className="item-filter-leads-modal">
                            <label>SEGUIMIENTO</label>
                            <select value={seguimiento} onChange={handleSelectSeguimiento}>
                                <option value="contactos">Total</option>
                                <option value="seguimiento">Seguimiento</option>
                                <option value="descartados">Descartados</option>
                            </select>
                        </div>
                        <div className="item-filter-leads-modal">
                            <label>ASESOR</label>
                            <input defaultValue={getCurrentUserName()} disabled />
                        </div>
                        <div className="item-filter-leads-modal">
                            <label>ETIQUETA</label>
                            <select value={tagUrl} onChange={handleSelectChange}>
                                <option value="todas">Todas</option>
                                <option value="Seguimiento">Seguimiento</option>
                                <option value="Llamar más adelante">Llamar más adelante</option>
                                <option value="No contesta">No contesta</option>
                                <option value="Apartado">Apartado</option>
                                <option value="No comprará">No comprará</option>
                                <option value="">Sin etiqueta</option>
                            </select>
                        </div>
                        <div className="item-filter-leads-modal">
                            <label>ORIGEN</label>
                            <select value={originUrl} onChange={handleSelectOrigin}>
                                <option value="todos">Todos</option>
                                <optgroup label="Medios Digitales">
                                    <option value="Base_Datos">Base de Datos</option>
                                    <option value="Facebook">Facebook</option>
                                    <option value="Facebook_Desktop_Feed">Facebook Ads</option>
                                    <option value="Google">Google</option>
                                    <option value="Google Ads">Google Ads</option>
                                    <option value="Instagram">Instagram</option>
                                    <option value="Instagram Ads">Instagram Ads</option>
                                    <option value="LinkedIn">LinkedIn</option>
                                    <option value="Whatsapp">Whatsapp</option>
                                    <option value="Tiktok">Tiktok</option>
                                    <option value="Página web">Página web</option>
                                    <option value="Redes sociales">Redes sociales</option>
                                </optgroup>
                                <optgroup label="Medios Tradicionales">
                                    <option value="Broker">Broker o Asesor Externo</option>
                                    <option value="Cambaceo">Cambaceo</option>
                                    <option value="Contacto Directo">Contacto Directo</option>
                                    <option value="Espectacular">Espectacular / Lonas</option>
                                    <option value="Inmobiliaria Externa">Inmobiliaria Externa</option>
                                    <option value="Periodico">Periódico</option>
                                    <option value="Radio">Radio</option>
                                    <option value="Recompra">Recompra</option>
                                    <option value="Revista">Revista</option>
                                    <option value="Referidos">Referidos</option>
                                    <option value="Señaletica">Señalética</option>
                                    <option value="Telefono">Teléfono</option>
                                    <option value="Televisión">Televisión</option>
                                    <option value="Volante">Volante</option>
                                    <option value="Walk-in">Walk-in</option>
                                </optgroup>
                                <optgroup label="Portales Inmobiliarios">
                                    <option value="Inmuebles 24">Inmuebles 24</option>
                                    <option value="Lamudi">Lamudi</option>
                                    <option value="Metros cúbicos">Metros cúbicos</option>
                                    <option value="Propiedades.com">Propiedades.com</option>
                                    <option value="Segundamano">Segundamano</option>
                                    <option value="Tu Hogar México">Tu Hogar México</option>
                                    <option value="Vivanuncios">Vivanuncios</option>
                                </optgroup>
                            </select>
                        </div>
                        <div className="item-filter-leads-modal">
                            <label>VISITÓ DESARROLLO</label>
                            <select value={visited} onChange={handleSelectVisited}>
                                <option value="Todos">Todos</option>
                                <option value="true">Si</option>
                                <option value="false">No</option>
                            </select>
                        </div>
                        <div className="item-filter-leads-modal filter--emojis">
                            <label>EMOJIS</label>
                            <div className="emoji-filter-row">
                                {[
                                    { key: 'feliz',     icon: '😊', label: 'Feliz',     range: '0-7 días' },
                                    { key: 'serio',     icon: '😐', label: 'Serio',     range: '8-13 días' },
                                    { key: 'triste',    icon: '😞', label: 'Triste',    range: '14-21 días' },
                                    { key: 'congelado', icon: '🥶', label: 'Congelado', range: '22-90 días' },
                                    { key: 'dormido',   icon: '😴', label: 'Dormido',   range: '+90 días' },
                                ].map(({ key, icon, label, range }) => (
                                    <button
                                        key={key}
                                        type="button"
                                        title={range}
                                        className={`emoji-filter-btn${emojiFilter === key ? ' emoji-filter-btn--active' : ''}`}
                                        onClick={() => setEmojiFilter(emojiFilter === key ? null : key)}
                                    >
                                        <span className="emoji-filter-icon">{icon}</span>
                                        <span className="emoji-filter-label">{label}</span>
                                        <span className="emoji-filter-count">{emojiCounts[key]}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="buttons-container-modal">
                        <button className="btn-cancel-modal" onClick={closeModalFilter} type="reset">Cancelar</button>
                        <button className="btn-reset-modal" onClick={resetAllFilters} type="button">Limpiar filtros</button>
                        <button className="btn-acept-modal" onClick={closeModalFilter} >Buscar</button>
                    </div>
                </Modal>
            </>
    )
}

export { ContactosV3 }